module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "daylaz"
  }, [_c('a', {
    attrs: {
      "id": "day1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 1")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Gearing Up for a New Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN ADOPTING A CAT (OR CATS)")]), _vm._v(", you’ll need a few basic supplies immediately. Look for sturdy, well-made items that serve their purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("BOWLS AND FOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You’ll need at least two per cat, for food and for water; add a third if you plan to serve your pet both dry and wet foods.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thick china, food-safe ceramics (avoid artisan pottery), CorningWare, and Pyrex are best. Plastic attracts bacteria that can cause acne to erupt on your pet’s chin. Some cats dislike the reflections and darkness of metal, so although stainless steel is safe, your pet may shun it. Never use vintage china or lead crystal, which could leach lead into a cat’s food or water.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A water bowl shouldn’t tip easily; some cats like to paddle a paw in the water. If you have multiple pets or your home has more than one story, provide multiple bowls in various locations. Note: Cats often prefer their water bowl to be at a distance from their food bowl(s); this also helps keep the water clean.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Dry food")]), _vm._v(" can be served in a curved or straight-sided cereal dish–size bowl. Resist using large bowls that could leave uneaten, drooled-on food mingling with the “fresh” food.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Wet food")]), _vm._v(" should be served in a deeply curved bowl about 4 inches (10.2 cm) in diameter. This will keep the food from being nosed out while Kitty chows down. In a multipet household, each cat should be given her own wet food bowl. Don’t expect them to peaceably share a platter. Place on a washable mat or tray to catch spills.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("LITTER BOX, LITTER, SCOOPER, AND CLEANING TOOL")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("Forget about fancy grids, flip-flop systems, and the like. A good-size litter box with high sides (start a kitten in a slightly lower one) is all you need. Note: Some cats balk at being enclosed by a lidded box; if you want to try this kind, get one whose separate lid could be left off if it doesn’t agree with Kitty. See ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day91"
    }
  }, [_vm._v("Day 106")]), _vm._v(" for more about selecting litter. (Boxes made from plastics with a slightly metallic-looking sheen are formulated to keep wastes from sticking.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Buy a scooper to remove solids and clumps of wet litter. Or just use a slotted spatula dedicated to that purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Keep a stiff brush or nylon sponge on hand for litter-box/scooper cleanup. Do not use this to clean human toilets, because some waste-borne diseases can be shared by cats and humans (see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 129")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("CARRIER")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Even if you don’t plan to travel with your cat, a carrier will be useful for visits to the vet. You want to be equipped in an emergency. If you have multiple cats, consider buying more than one carrier, just in case. For more about choosing a carrier, see "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day31"
    }
  }, [_vm._v("Day 36")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0009-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "day2"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 2")])]), _c('a', {
    attrs: {
      "id": "day2"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("The Proverbial Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU MAY RECOGNIZE THESE")]), _vm._v(" familiar cat proverbs: When the cat’s away, the mouse shall play . . . curiosity killed the cat . . . there is more than one way to skin a cat . . . and so on. Other proverbs, however, seem unique to particular countries or regions.")]), _vm._v(" "), _c('div', {
    staticClass: "blackquotex"
  }, [_c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• Books and cats and fair-haired little girls make the best furnishing for a room.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—France")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• A blind cat catches only a dead rat.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—China")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• A cat has nine lives. For three he plays, for three he strays, and for the last three he stays.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—England")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• A house without a dog or cat is the house of a scoundrel.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• A peasant between two lawyers is like a fish between two cats.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Catalonia")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• After dark all cats are leopards.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Native America")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• An old cat will not learn how to dance.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Morocco")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• Beware of people who dislike cats.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• Cats don’t catch mice to please God.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Afghanistan")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• I gave an order to a cat, and the cat gave it to its tail.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—China")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• If stretching made money, all cats would be wealthy")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Ghana")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• In a cat’s eye, all things belong to cats.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—England")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• In the eyes of a mouse, the cat is a lion.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Albania")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• It is a bold mouse that nestles in the cat’s ear.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—England")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• Nature breaks through the eyes of a cat.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• The borrowed cat catches no mice.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Japan")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• The cat was created when the lion sneezed.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Middle East")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• The cat who frightens the mice away is as good as the cat who eats them.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Germany")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• The man who loves cats will love his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Russia")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• To please himself only the cat purrs.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• When the mouse laughs at a cat, there’s a mouse hole nearby.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Nigeria")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlistx"
  }, [_vm._v("• Women and cats in the house, men and dogs in the street.")]), _vm._v(" "), _c('p', {
    staticClass: "att1"
  }, [_vm._v("—Catalonia")])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day2"
    }
  }), _c('a', {
    attrs: {
      "id": "day3"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 3")])]), _c('a', {
    attrs: {
      "id": "day3"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Find the Best Vet Possible")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("VETERINARIAN IS AN ADVISER")]), _vm._v(", a medical expert, and someone you can rely on for emergencies. You should feel comfortable expressing concerns to this person and asking questions—even the most basic ones, such as, “What if my kitty won’t use the litter box?” You will turn to your vet when your cat experiences health issues, or when you have general questions about pet wellness. But also, your vet can serve as a valuable counselor as you raise your cat. You will share some of the most exciting (birth of kittens) and devastating (end of life) events with your vet. Do not make this decision without “interviewing” your vet and choosing a medical expert with whom you are compatible. (It helps if your cat warms up to the vet, too.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here are some pointers for finding a reputable vet:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Ask your cat-lover friends and the breeder/kennel where you adopt your cat for referrals.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Call each veterinarian on your list to schedule a consultation before you bring home your new kitten or cat. Your vet can provide valuable tips for selecting a kitten and supply you with questions to ask the breeder or other source.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Find out whether there is a fee for your visit.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• How close is the vet’s office to your home? Although the closest option might not be the best fit, consider the distance you will drive for routine appointments and in case of an emergency.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• What are the clinic’s hours of operation? Find out how the office handles emergency calls after hours, too.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Ask to be introduced to the staff so you can learn who is behind the scenes and how the clinic operates.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Sit in the waiting room for a while to soak up the atmosphere and find out how the staff interacts with patients.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After your visit, consider your experience and fill out this worksheet, which will help you decide whether the vet you interviewed is the right match for you and your cat.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "sidebartitle"
  }, [_c('strong', [_vm._v("Veterinarian’s Name:"), _c('br'), _vm._v("Date of Consultation:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Did you feel comfortable talking with the vet and staff?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Are the vet’s philosophies and communication style in line with your own?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" How do you rate the vet’s bedside manner?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Would you feel comfortable asking him or her any question, however silly it might seem?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Is the staff friendly, efficient, and helpful?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Is the office easy to reach and is the staff accessible in case of emergencies?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Is the office inviting to adults and your pets, or is it either too sterile or too messy for you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Does the vet seem to know about the latest medical advances?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Are there educational materials for you to take home?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/squ.jpg"
    }
  }), _vm._v(" Do they offer boarding?")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "day4"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 4")])]), _c('a', {
    attrs: {
      "id": "day4"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Making a Scratching Box")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVE YOUR KITTY AN APPROVED PLACE")]), _vm._v(" to scratch with this simple box made of recycled cardboard. Choose a box that is longer and wider than your cat, so she will have room to stretch out when she scratches.")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shallow corrugated cardboard box for the base (lids from office paper boxes work well)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cardboard sheets")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tape measure")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cutting mat or scrap cardboard (to protect work surface)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Long metal ruler or other straightedge")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fine, dark marking pen")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Utility or craft knife")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("White household glue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clamps or long, thick rubber bands")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Catnip")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Cut all sides of your box down to 3 to 4 inches (7.6 to 10.2 cm) in depth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Measure the length, width, and depth of the interior of the box. Subtract W inch (6 mm) from each measurement, and note those dimensions. Those will be the length, width, and height of your insert. Set the box aside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Protect your work surface with a cutting mat or scrap cardboard.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Place a piece of cardboard on the work surface with the corrugation lines running vertically (away from you). If necessary, use a metal ruler and a utility knife to create straight edges. Repeat this for the remaining pieces of cardboard.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" From the straight edge on the side of the cardboard, measure and mark the length of your box across the top and bottom of the cardboard. Connect these two marks with the metal ruler and cut along the metal ruler. Your cardboard should be square on at least three sides and as wide as the length of your box.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" Using this first piece of cardboard as a template, mark matching cutting lines on the other pieces of cardboard. Use the metal ruler as a guide to cut along the lines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" Place one of the cut pieces of cardboard on the work surface with the corrugation lines running vertically. From the straight edge on the top or bottom, measure and mark off the cardboard in increments corresponding to the height of your insert. Using the metal ruler as a guide, connect the marks and cut along the metal ruler. You should now have several strips of cardboard that correspond to the length and height of your insert.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Repeat step 7 with the remaining pieces of cardboard, until you have enough strips that when stacked will fill the width of the box.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("9.")]), _vm._v(" Apply a generous amount of glue to one side of a cardboard strip and glue it to another one. Glue a third strip to the first two. Continue this until you reach the correct width, aligning as you go. Once the glue gets tacky, align the strips once more and clamp or rubber band them together. Allow the glue to dry thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("10.")]), _vm._v(" When the glue is dry, remove the clamps or rubber bands and place the insert into the box. Put some catnip on the surface, and let your cat enjoy!")]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0013-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("glue, strips of corrugated cardboard")])]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0013-02.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Top: Scratching box insert (cardboard strips, glued together). Bottom: empty scratching box.")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "day5"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 5")])]), _c('a', {
    attrs: {
      "id": "day5"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Cat Genetics")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E’VE ALL SEEN LITTERS OF KITTENS")]), _vm._v(" with a rainbow of colors and markings, or even different lengths of fur. How does this happen? In a word, genetics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cats have thirty-eight chromosomes (eight fewer than people). Every female cat has two X chromosomes, and every male has an X and a Y. Within each chromosome are genes that govern characteristics such as hair and eye color. Which genes link when parents “bond” determines a cat’s looks, among other physical and behavioral traits.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Gender:")]), _vm._v(" A male kitten will inherit one or the other X chromosome from his mother and a Y from his father; a female kitten will inherit an X chromosome from each of her parents. There are four ways gender may be decided:")]), _vm._v(" "), _c('div', {
    staticClass: "blackquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Boy: Xa (mother) + Y (father)"), _c('br'), _vm._v("Boy: Xb (mother) + Y (father)"), _c('br'), _vm._v("Girl: Xa (mother) + X (father)"), _c('br'), _vm._v("Girl: Xb (mother) + X (father)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Fur length:")]), _vm._v(" Short fur is a dominant trait; long hair is recessive. This means that (a) if the kitten inherits both genes for short hair, the kitten will have short hair; (b) if one gene is for short hair and the other is for long hair, the kitten’s fur will be short; (c) to have long hair, both of the kitten’s fur genes must be long. There are exceptions to these rules, depending on the hair length of cats from previous generations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Fur color:")]), _vm._v(" Cats’ chromosomes carry genes for color and other genes that can prevent colors from emerging in their offspring.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('strong', [_vm._v("The white gene")]), _vm._v(" is a special case: It is dominant and the cat equivalent of being albino, but with colored eyes. (Read more about eye color on ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 330")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Bicolor cats")]), _vm._v(" such those with white bibs and feet have the white spotting gene, which cancels out color only in certain areas of the fur.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Silver cats")]), _vm._v(" have a dominant gene that prevents any yellow from appearing in their fur.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Red fur and black fur")]), _vm._v(" are carried by the X chromosomes. A female inheriting a red X chromosomes and a black X chromosomes may be a tortoiseshell or calico because both colors will show. But a male cat only has one X chromosomes, so he may be red or he may be black, but usually not both at the same time (if he does inherit both, that is a genetic glitch and he will be sterile).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("The agouti gene")]), _vm._v(" produces ticking and stripes. Cats who inherit the agouti gene from both parents will have a tabby or ticked coat.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")]), _vm._v(" >")]), _vm._v(" X chromosomes dictate the red or black color of a cat, and because female cats have two X chromosomes, their coats can carry both colors. However, a male cat only has one X chromosome, so his coat can be red or black, but usually not both. If you see a male calico or tortie, you can be sure he has an extra X chromosome—a genetic mutation that renders him sterile.")])]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day6"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 6 + 7")])]), _c('a', {
    attrs: {
      "id": "day6"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Feline Body Language")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CATS USE THEIR PAWS, LIPS")]), _vm._v(", and entire body to show us what’s on their mind.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Shaking a paw at her food:")]), _vm._v(" the universal cat gesture for disliking the offering. A cat may do this upon first encountering the offending item, or to subtly signal that she is finished eating.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Rubbing against an owner’s legs:")]), _vm._v(" A sign of approval—and possession; your cat is marking you with her scent glands.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Bumping her head against you:")]), _vm._v(" A positive gesture you can interpret as a cat kiss, or approval for an action; the head bump signals, “Yes!” You can even offer your cat a gentle bump with your own. If you ask Kitty something and she responds with a head bump, there’s your answer!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Smiling:")]), _vm._v(" Cats, like dogs, are capable of a smile. Stroke Kitty beneath her chin and watch her lips widen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Kneading:")]), _vm._v(" A characteristic gesture tracing back to all those warm feelings associated with pressing their mother’s teat area to express milk. Kittens and adult cats enthusiastically “make bread” on soft surfaces as they purr.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Pawing:")]), _vm._v(" Cats also make the connection that their front paws correspond to our hands, and may imitate human gestures. Some enjoy “holding hands” with yours, or wrapping their fingers around the tip of one of yours, squeezing it in a mini-knead. Your cat may use a hand to tug at you for attention, or even to tug or pat at the corresponding area of your head where she’d like to be rubbed or scratched on hers. An adept kitty will use her forepaws to open doors and cabinets, press on the buttons of electronic devices, or “claim” food from your dish with a tap. (She isn’t stupid; she knows once she has touched it that you probably won’t want to eat that piece!)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you notice your cat holding a paw tightly across her face while she sleeps, do not intervene. This is her way of reducing oxygen flow to induce a deeper level of sleep. When she is refreshed, she’ll wake up fine on her own.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")]), _vm._v(" >")]), _vm._v(" A cat’s paws contain sweat glands; when your cat is feeling overheated, she will leave damp prints as she walks.")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "day7"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 8")])]), _c('a', {
    attrs: {
      "id": "day7"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Introducing a Kitten to Her New Home")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COMING HOME FOR THE FIRST TIME")]), _vm._v(" is a big change for a kitten. Here are some tips for making the transition less stressful for both of you.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('strong', [_vm._v("Clear time:")]), _vm._v(" Schedule your cat’s homecoming for a time when you’ll have a few days at home without other obligations, such as the beginning of a weekend, so you’ll have plenty of time to spend with her. Prepare a safe room for her (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 302")]), _vm._v(") ahead of time.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Set boundaries:")]), _vm._v(" Confine Kitty to the safe room and keep a close eye on her for a few days. If you have children or other pets, keep them away from her until she becomes acclimated (see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 309")]), _vm._v(" and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 351")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Take it slow:")]), _vm._v(" Let her come to you when she is ready. Leave her carrier in the safe room so she will have a somewhat familiar place to retreat to if she feels overwhelmed. Try not to hover, but do check on her every half hour or so and offer her a treat or a toy once she starts to get comfortable exploring on her own. Let her set the pace for your interactions, and recognize that it may take anywhere from a few hours to a few days for her to feel comfortable enough to approach you. Once she does, give her plenty of attention to help her bond with you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Give her space:")]), _vm._v(" Once your new kitten is familiar with her new litter box and feels comfortable with you, you can introduce her to other parts of the house. Close off any rooms you don’t want her to explore, then open the door to her safe room.")]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day8"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 9")])]), _c('a', {
    attrs: {
      "id": "day8"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("A Brief History of Commercial Food and Litter")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LTHOUGH CATS HAVE BEEN")]), _vm._v(" household pets for thousands of years, the notion of specially marketed food and litter for them is very modern.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For most of their time on Earth, cats have been expected to earn their keep by dispatching—and devouring—mice and other vermin, supplemented by scraps of butcher’s meat and bowls of milk. For the most part, cats were expected to work for their supper until the 1950s, when canned cat food hit the market. Dry and semimoist food followed, and in the 1980s, “scientific” diets were developed and brands rolled out specialty foods for older cats, overweight cats, and indoor cats. Today, some manufacturers add vegetables or herbs such as parsley to cat foods, to appeal to owners who are themselves turning away from a meat diet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meanwhile, the relatively recent exclusively indoor lifestyle of many cats sparked a need for cat litter. Its first major manufacturer was U.S. inventor Ed Lowe, who figured that fuller’s earth, a superabsorbent clay, would be an ideal throwaway product for soaking up cat wastes. Lowe coined the term "), _c('em', [_vm._v("kitty litter")]), _vm._v(", his brand name for his product. In 1964, he began to sell the clay nationwide under the Tidy Cat label.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "day8"
    }
  }, [_vm._v("Nowadays, various kinds of clay are used for litter, as well as products made from recycled newspaper pellets, grains, silica gel, and wood shavings. See ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day91"
    }
  }, [_vm._v("Day 106")]), _vm._v(" for how to choose the best litter for your cat.")]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 10")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Safe Toys for the Thrifty Owner")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU INVEST IN A CACHE OF")]), _vm._v(" fancy cat toys, but your cat is more interested in batting at your newspaper or running off with the luxury yarn you purchased to make a sweater.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("House cats need to stay busy with play, and we must make sure that the toys we offer are a safe and tempting alternative to household hazards. Avoid small balls, tassels, bells, yarn, ribbon, and rubber bands.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Look for nontoxic labels on toys so you can make sure the materials, if ingested, will not harm your fair feline.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Make sure trim and decorations are securely fastened to toys. Your cat will easily tear off glued-on “flair” and may swallow small pieces of fabric or plastic googly eyes, whatever the embellishment.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Steer clear of toys with small pieces or parts that can become dislodged during play.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Introduce these safe toys to your kitty’s play stash (some of them are household items, saving you dollars at the pet store): plastic shower curtain rings, stuffed animals that are small enough to carry around or large enough to wrestle, plastic balls with noisemakers (squeakers), Ping-Pong balls, plastic practice golf balls, and catnip-filled soft toys. Allow your cat to play in a cardboard box (with the top removed). Buy your cat infant toys made for humans, which by law (in many countries) must be made of nontoxic, nonswallowable materials. Additionally, check Thursday entries in this book for safe cat toys you can make.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("String is especially dangerous because a cat’s tongue contains tiny hooklike barbs called papillae, which are helpful for grooming. Once a piece of string catches on these prickly barbs, the cat has difficulty spitting it out.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0017-01.jpg"
    }
  })])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "day10"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 11")])]), _c('a', {
    attrs: {
      "id": "day10"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Taking Great Cat Photos")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH TODAY’S DIGITAL CAMERAS")]), _vm._v(", it’s cheap and easy to take a few dozen shots and end up with one that looks okay for your holiday card. But taking great photos of your cat doesn’t have to be left to chance.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Watch the background.")]), _vm._v(" Simple, uncluttered backgrounds are generally best. Move your vantage point to put the focus on Kitty, not what’s behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Mind the contrast.")]), _vm._v(" If your cat is dark, choose a light-colored background; if she’s light, choose a dark-colored background.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Avoid using the flash when possible.")]), _vm._v(" Using a flash often distorts colors, creates red-eye (or green-eye!), and causes harsh shadows, in addition to startling and temporarily blinding your cat—they have sensitive eyes. Plan your photo session for a time and place where you will have plenty of natural light, such as a sunny afternoon windowsill. You will need a flash for many action shots, though; just remember to back away to avoid startling her and prevent flash burnout.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Enlist help.")]), _vm._v(" If you want a photo of your cat leaping, have a friend hold a tempting toy or treat above the cat’s head. Or if you’re having trouble getting your cat to look at you, have your friend stand behind you with the toy and attract her attention.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "day11"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 12")])]), _c('a', {
    attrs: {
      "id": "day11"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Showing Off Our Cats")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE CAT SHOWS WE ENJOY")]), _vm._v(" As fanciers today started with less pomp and circumstance. The earliest cat shows were part of farmers’ or country fairs.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "day11"
    }
  }, [_vm._v("The 1851 Great Exhibition at the Crystal Palace, in London, was the first world’s fair, housed in an enormous, glassed building. Other world’s fairs followed, and in 1871 cat fancier Harrison Weir organized the first cat competition at the Crystal Palace, with points for particular breeds, markings, and so on (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 303")]), _vm._v(" for more about Weir). Inspired by this show, others began to crop up around the UK. The first successful U.S. cat show with a significant turnout of 150 cats was held at Madison Square Garden in New York City, in 1895. This led to other American cat shows, as well as the proliferation of shows in other countries. Today, many events are available for cat lovers and breeders to show their cats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Concurrent with the rise of cat shows came the development of cat clubs, either those specializing in one breed or generalist organizations. These associations set the rules about what is and is not acceptable as feline traits at cat shows being held in their respective nation, as well as record pedigrees (see "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day17"
    }
  }, [_vm._v("Day 19")]), _vm._v("). Standards differ from country to country and even group to group.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whether or not you want to raise and show a winning cat, cat shows are a valuable resource for learning about and seeing prime examples of particular breeds. There, you can network with other cat lovers and browse commercial and artisan merchandise. The best way to get the schedule of a cat show near you is to contact national cat fancier organizations and regional cat clubs on the Web or look in the resource section of your country’s cat magazine(s).")]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 13 + 14")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Don’t Worry, They’re Only Playing!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR CAT POUNCES ON HIS")]), _vm._v(" feline sibling, who counters with a paw in the face. More pouncing, stalking, chasing, and sometimes roughhousing ensues. Should you intervene? Determine whether your cats are on guard or only playing by tuning into these behavioral clues.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Healthy play:")]), _vm._v(" Stalking, chasing, and pouncing are normal play—and it can get rough. To make sure activity stays within safe boundaries, introduce toys, scratching posts, and other stimulators. By diverting attention away from the feline playmate and toward a toy, you can refocus the playtime and prevent any accidental scratches or nips. Play is generally quiet, though cats may hiss or make meowing sounds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Foul play:")]), _vm._v(" You’ll know that cats are fighting by the sound and look of their interaction. You’ll hear wailing and howling, and one cat will act as a dominant force, intimidating the other. They won’t “trade” pounces or take turns chasing one another. Unlike play, which is mutual, fighting is characterized by each cat’s offensive or defensive roles. After play, cats will act as friends, even curling up together for a nap. Fighting cats walk separate ways, one scared of the other.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you must break up a cat fight, keep your hands away from the action. Try directing a hose on the aggressive cat to drive it away. Splash a glass of water directly on the aggressor’s face. Push a broom between the two cats to separate them. If cats are not yet making contact and are in the frozen position, hold a newspaper in front of them to block their view of each other. Ideally, the frightened cat will slink away and the aggressor will become calm enough for you to pick up and secure. (Never try to pick up a cat who is still in attack mode!)")])]), _c('div', {
    staticClass: "sidebarc"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Make sure your cat receives regular booster shots to protect against feline immunodeficiency virus (FIV). An unvaccinated cat can get the disease if an infected cat bites him. (Read more about vaccinations on ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day15"
    }
  }, [_vm._v("Day 17")]), _vm._v(".)")])]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 15")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Litter Training Your Kitten")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NLIKE HOUSEBREAKING A DOG")]), _vm._v(", litter training a kitten is a quick and relatively simple process. Litter boxes mimic the kinds of places cats in the wild select to eliminate wastes, so it’s usually easy to direct their natural instincts toward the litter box.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Select a litter box that is kitten-size. Full-size litter boxes can be intimidating. Make sure the sides are low enough that your kitten can easily climb in and out of it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Place the litter box in a quiet, low-traffic, catproofed area, well away from your cat’s food and water but easily accessible.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Fill the litter box with 2 inches (5.1 cm) of unscented, nonclumping clay litter. Clumping litter is not recommended for kittens under six months, and scented litter can confuse them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Place the kitten in the litter box and gently hold her front paws and scratch them in the litter. This is an instinctual action, so she should catch on quickly. Let her jump out of the box when she’s ready, whether or not she has eliminated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Watch Kitty closely. When she starts sniffing or scratching, especially after eating or playing, pick her up and take her to the litter box. Take a few steps away to give her some privacy. Praise her for sniffing and scratching there, even if she doesn’t eliminate right then. Keep this up until she is regularly finding and using the litter box on her own.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Cats naturally prefer a clean litter box to other surfaces in your home, although some may be tempted by the soil in potted plants. Keep the litter box clean, and consider covering the soil in your potted plants with stones or netting. (See ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 172")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Most kittens arrive at their new home already litter trained if they’ve come from a breeder, shelter, or other third party. Even so, follow the litter training steps until your kitten is accustomed to her new home and litter box.")])]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 16")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Black Cats: Good or Bad Luck?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F A BLACK CAT CROSSES YOUR PATH")]), _vm._v(", are you superstitious that this incident will bring you bad luck? That depends on which stories about the infamous "), _c('em', [_vm._v("chat noir")]), _vm._v(" you believe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Black cats have been blamed throughout history for all sorts of turbulence and turmoil, and they have been widely associated with witchcraft. Some believed black cats could be manipulated by witches, transformed by spells to carry out evil doings. Black cats were thought to be a form of their witch owners. Even today, we hear of sick-minded humans who hurt cats on Halloween—a good reason to keep Kitty in the house on this holiday.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the Middle Ages, before witchcraft was dinner conversation (if it ever was), some believed the devil took the form of a black cat, so these felines were regularly hunted down on holy days such as Easter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But black cats don’t have a bad reputation everywhere. In Scotland, it is believed that an unfamiliar black cat on a house porch is a sign of upcoming prosperity for those who live there. Black cats were protectors in England. Fishermen’s wives were said to keep black cats in the house while their husbands were gone to keep the family safe. In America, aside from the belief that a black cat crossing one’s path is a bad omen, some believe that the bones of black cats are magical.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Incidentally, black cats are less likely to be adopted from shelters than cats with different colored coats. Sadly, a superstition can result in an unfortunate fate for these cats—and for no sound reason. Talk to your animal shelter about how you can promote adoption of black cats and felines in general.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0021-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "day15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 17")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Essential Vaccinations")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vaccinations can minimize the impact of a future disease or prevent it completely. Indoor and outdoor cats have different vaccination needs; vaccines are especially important for young kittens, who are highly susceptible to infectious disease because their immune systems are not fully mature. Adult cats should receive regular booster shots to maintain disease protection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So how much protection does your kitten or cat truly need? Your veterinarian will help you decide an appropriate regimen depending on your cat’s lifestyle, but the FVRCP combination is a must. Kittens may begin a vaccination program immediately at four weeks of age.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("FVRCP")])]), _vm._v(" shot is a core vaccine that protects against feline rhinotracheitis, calici, and panleukopenia viruses, which affect the upper respiratory, digestive, and nervous systems; bone marrow; and lymph tissue.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Feline leukemia")])]), _vm._v(" is the most common cause of cancer, and it can lead to immune deficiency that limits a cat’s ability to ward off infection. The FeLV shot will protect cats who wander outside unsupervised from being exposed to an infected cat’s saliva, excrement, or contact (bite). If your cat is not contained to the indoors, the FeLV vaccine is a must.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Chlamydophila")])]), _vm._v(" can cause pneumonia in kittens.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Feline infectious peritonitis")])]), _vm._v(" (FIP) is a viral immune-mediated disease.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Feline immunodeficiency virus")])]), _vm._v(" (FIV) is feline AIDS and is transmitted through bite wounds. Like other “optional” vaccines, house cats who have no exposure to the outdoors or are carefully supervised may not require this protection. However, some cat owners would argue that immunization is always a good idea—just in case.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Giardia")])]), _vm._v(" is a gastrointestinal disease that can spread by infected litter boxes in multicat households or impure drinking water.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "sidebartitle"
  }, [_c('strong', [_vm._v("VACCINATION PLANNER")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "6",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("4 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("FIP (intranasal; boosters every 6 months)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("FVRCP series (administered every 2 to 3 weeks until 12 weeks of age)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("8 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("FVRCP series; FeLV; chlamydophilia; giardia; FIV")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("10 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("FVRCP series; giardia (second in series; annual booster); FIV (second in series)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("11 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("FeLV (second in series; boosters every 1 to 3 years); chlamydophilia (annual booster)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("12 weeks")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("FVRCP series; FIV (third in series; annual booster)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("4 months")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rabies; every 1 to 3 years depending on vaccine and location")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1 year")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Annual checkup; begin schedule of booster shots")])])])])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "day16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 18")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Stimulation for the Indoor Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDOOR CATS GENERALLY DO NOT")]), _vm._v(" receive as much stimulation from their environment as outdoor cats do, especially with their owners’ busy lifestyles. Many feline family members stay at home while the “parents” go off to work. It is important to make cats’ everyday environment interesting and engaging to prevent the boredom that can lead to weight gain or destructive behavior. Here are a few ways to provide much-needed stimulation for your indoor cats:")])]), _c('p', {
    staticClass: "bulletlist"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("Provide plenty of toy options.")]), _vm._v(" Offer catnip toys, rolling balls and toys, noisemaker toys, foraging toys in which you can place treats (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day58"
    }
  }, [_vm._v("Day 67")]), _vm._v("), and dangling toys that encourage jumping and stretching.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Rotate toys.")]), _vm._v(" Change up the toy selection every other week or so by “hiding” some in the cupboard for later so toys feel new to your cat all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Set aside playtime.")]), _vm._v(" Laser pointers and “birdie”-on-a-string toys are great for encouraging vigorous play. (When playing with laser pointers, be careful not to shine the laser in your cat’s eyes.)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Provide a perch.")]), _vm._v(" A window to the world is easy entertainment for cats, who naturally like to keep an eye on birds and squirrels. Place a cushion on wide windowsills or attach perches to the windowsills. Another solution is to place a chair or low bookcase in front of a window that can become “his” spot.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Turn on the tube.")]), _vm._v(" Many cats don’t respond to what’s happening on the television, but if yours does, consider occasionally tuning in a channel dedicated to animals or nature or playing a DVD made specifically for entertaining cats. Just make sure your television is out of reach or sturdy enough to take an occasional swat with a paw. You don’t want Kitty to knock over your new flatscreen.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0023-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day17"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 19")])]), _c('a', {
    attrs: {
      "id": "day17"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("The Difference Between Registered and Pedigreed")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIONAL CAT ORGANIZATIONS")]), _vm._v(" have complex rules for which qualities constitute a breed and which characteristics of those established breeds are acceptable for shows. Here are some important facts that cat fanciers planning to show their felines should know:")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('strong', [_vm._v("Classification:")]), _vm._v(" Cat classification is based on genetics (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day5"
    }
  }, [_vm._v("Day 5")]), _vm._v("). Some breeds have been distinct and plentiful for a long time. Others are not registered for decades, sometimes simply because the cats were not considered fashionable (Maine Coons suffered this fate), or perhaps because the characteristics are a new mutation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Recognition:")]), _vm._v(" Registration begins with a voting process and is the first step in the pedigree process. Breed recognition is not global; countries often adopt different standards. Registration can take up to five years as cats pass through a "), _c('em', [_vm._v("preliminary")]), _vm._v(" and "), _c('em', [_vm._v("provisional")]), _vm._v(" stage. Standards are established to determine breed characteristics, including fur color and markings, body type, color of eyes, and other details such as tail length and ear shape. Full recognition is called championship status.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Pedigreed:")]), _vm._v(" To be "), _c('em', [_vm._v("pedigreed,")]), _vm._v(" a kitten must have fully registered parentage dating back at least four generations. Registration documents detail breed, ancestry, owners, cat name, and breeder name. Every time a pedigreed cat obtains a new owner, he must be reregistered, to track his lineage.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > A "), _c('em', [_vm._v("natural")]), _vm._v(" breed is one that developed without breeder intervention, such as the Turkish Van; an "), _c('em', [_vm._v("established")]), _vm._v(" breed developed from crossing two natural breeds to create a new breed, such as the Burmese; and a "), _c('em', [_vm._v("hybrid")]), _vm._v(" involves repeated crossbreedings to perpetuate the breed’s standard, such as the Exotic Shorthair.")])]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 20 + 21")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("What’s Your Cat’s Zodiac Sign?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU DON’T NEED A HOROSCOPE")]), _vm._v(" to confirm you’re compatibility with Kitty. But for fun, decide whether your cat displays behaviors that are characteristic with her sign.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Aries")]), _vm._v(" "), _c('em', [_vm._v("(March 21 to April 19)")]), _vm._v(": Lively, energetic, daring, adventure seeking, and more independent than most. These cats know what they want and are confident they will get it. They can be impatient, impulsive, and fearless.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Taurus")]), _vm._v(" "), _c('em', [_vm._v("(April 20 to May 20)")]), _vm._v(": Practical, cautious, purposeful, persistent, patient, and exceptionally sensitive. These cats have sharp intuition and an active mind.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Gemini")]), _vm._v(" "), _c('em', [_vm._v("(May 21 to June 21)")]), _vm._v(": Physically active, athletic, stimulated, fast-paced, adaptable, and thirsty for new experiences. Your Gemini cat acts like a dog, loving attention from people.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Cancer")]), _vm._v(" "), _c('em', [_vm._v("(June 22 to July 22)")]), _vm._v(": Emotional, generous, intuitive, adaptable, and nurturing. These cats are receptive to people and their surroundings. They have a maternal nature and an expressive face, and they love to play creative games.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Leo")]), _vm._v(" "), _c('em', [_vm._v("(July 23 to August 23)")]), _vm._v(": Warm, bright, motivated, and eager to make an impression. Leos are dynamic balls of energy, generous in nature, and very loyal. Your Leo cat has a pioneering spirit and isn’t afraid to blaze the trail.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Virgo")]), _vm._v(" "), _c('em', [_vm._v("(August 24 to September 22)")]), _vm._v(": Analytical, investigative, cautious, studious, intelligent, and sometimes demanding. Virgo cats are quick, logical thinkers. They will outsmart you—watch out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Libra")]), _vm._v(" "), _c('em', [_vm._v("(September 23 to October 22)")]), _vm._v(": Social, caring, youthful, and even wacky. These cats will always be young at heart. They won’t hide from houseguests and will look for every opportunity to entertain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Scorpio")]), _vm._v(" "), _c('em', [_vm._v("(October 23 to November 21)")]), _vm._v(": Strong but silent, determined, loyal, complex, and emotional. Scorpio cats give 100 percent to those they love—there are no half measures when they are attached to someone. Their amazing eyes are windows to their emotions. They can be manipulative, but they will never let down their owners. They work and play tirelessly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Sagittarius")]), _vm._v(" "), _c('em', [_vm._v("(November 22 to December 21)")]), _vm._v(": Confident, jolly, enthusiastic, light-hearted, and optimistic. These cats love adventure and freedom. They are easily bored without mental stimulation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Capricorn")]), _vm._v(" "), _c('em', [_vm._v("(December 22 to January 19)")]), _vm._v(": Practical, down-to-earth, shy, cautious, and suspicious of strangers, but committed to completing any task. Capricorn cats are known for their courage, concentration, and keen focus.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Aquarius")]), _vm._v(" "), _c('em', [_vm._v("(January 20 to February 18)")]), _vm._v(": Revolutionary, self-sufficient, zesty, determined, and headstrong. No one will tell an Aquarius cat how to live. These cats occasionally have an attitude, but they make their mark as individuals who are deeply sensitive and caring underneath.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Pisces")]), _vm._v(" "), _c('em', [_vm._v("(February 19 to March 20)")]), _vm._v(": Compassionate, sensitive, intuitive, deeply emotional, and a daydreamer. Pisces cats always lend a helping hand, and they sense their owners’ feelings and respond by nurturing.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "day19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 22")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Introducing an Adult Cat to His New Home")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINGING HOME AN ADULT CAT")]), _vm._v(" is much like introducing a new kitten to your home (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day7"
    }
  }, [_vm._v("Day 8")]), _vm._v("): You’ll need to set up a safe room and allow him to acclimate at his own pace. But there are a few special considerations to be aware of when introducing an adult cat to your home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Adult cats tend to take longer than kittens to adjust to new people and surroundings, so be prepared to give him more time to explore his environment and get used to his new family and home. Especially if he came from a shelter or a bad situation, he may need a week or longer to feel secure. Be patient and continue to let him set the pace for your interaction. Give him affection and praise whenever he will let you so he knows you’re a caring person who can be trusted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Consider using a spray or plug-in dispenser with synthetic feline facial pheromones in his safe room. These mimic the natural facial pheromones cats use to mark their territory and have a calming effect on most cats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Follow the instructions that come with the product. You can also use these in other areas of the house once your new cat is free to roam.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Adult cats have established their personality, so take time to get to know his. If he doesn’t enjoy sitting in your lap, don’t try to turn him into a lap cat. If he doesn’t prefer the company of other cats, make sure he has a space to call his own rather than forcing him to share bedding or bowls with others. If he doesn’t like to be picked up, resist the urge to carry him like a child. Your cat will adjust to your home on his terms.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Adopting an adult cat can be a very rewarding experience for both of you. A bit of preparation and extra patience on your part can make his transition as stress-free as it can be.")]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 23")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("The Owl and the Pussy-Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICTORIAN WRITER")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DWARD")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")]), _vm._v(" (1812–1888) was very much a cat lover. He adored his own cat, Foss, whose truncated tail resulted from an unfortunate run-in with a servant. Foss is immortalized in various sketches Lear made of his pet, and his owner purportedly cared so much for Foss’s comfort that when he moved, he made sure the interior of his new dwelling exactly matched that of the last, so Foss wouldn’t be disoriented! (Now, that’s devotion!) Foss lived to the respectable age of fourteen, and a tomb-stone honoring him is in the Italian garden of Lear’s estate.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("Lear is probably best known today for his nonsense poem “The Owl and the Pussy-Cat,” written in 1871 during the heyday of Lewis Carroll’s Alice books (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 338")]), _vm._v(") in which nonsense poetry also features cats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lear’s owl flatteringly serenades and proposes to a plump tabby cat (bearing a distinct resemblance to Foss, in Lear’s original illustrations of the poem, but granted a full-length tail—artistic license) as they sail in a green boat. For lack of a wedding ring, they postpone the wedding for a year and a day, until they reach a land where they meet a pig with a ring through its nose. The pig willingly gives up the ring so that the service can be performed by an obliging turkey, and the animals celebrate along the sandy beach by dancing by the light of the moon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lear also wrote a little-known unfinished poem about the couple’s offspring, which charmingly begins, “Our mother was the Pussy-Cat, our father was the Owl, / And so we’re partly little beasts and partly little fowl.”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0027-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 24")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Know Your Cat’s Vital Signs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDERSTANDING HOW TO MEASURE")]), _vm._v(" and evaluate your cat’s vital signs will help you determine whether your pet is sick and needs veterinarian care. Determine your cat’s “baseline” temperature, pulse, and respiration by measuring these stats on any given day. Take your cat’s pulse following activity and naps to note the normal increase in beats per minute your cat experiences. Same goes for breathing. Feline body temperature also varies by a few degrees.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Record this information in your health documents (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day70"
    }
  }, [_vm._v("Day 81")]), _vm._v("). Your vet will record this information during health checkups, but it’s handy to learn how to measure vital stats yourself and keep a record so you do not delay medical care in case of an emergency. We provide benchmarks here, but every animal is different.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("TEMPERATURE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use a digital rectal pediatric thermometer lubricated with petroleum jelly to take your cat’s temperature. To prevent your cat from squirming, stand her on a counter or sit at her level on the ground. Hold her securely with one arm, her face resting in the crook of your elbow. Using your free hand, lift the cat’s tail as you insert the thermometer 1/2 inch (1.3 cm) into your cat’s rectum. You’ll feel the muscle tighten and relax. Hold the thermometer there for two minutes to get an accurate reading. During this time, talk sweetly to your cat and assure her so she stays calm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Normal temperature:")]), _vm._v(" 100°F to 103.1°F (37.8°C to 39.5°C)")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("HEART RATE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shhh—listen carefully. What does your cat’s heartbeat sound like? It should resemble a beating drum: lub-dub, lub-dub. Check heart rate by locating your cat’s pulse along the femoral artery (inner thigh) or under the arm. Be sure to use your second and third fingers, not your thumb, which has a radial artery running through it that “beats” and can cause an inaccurate reading. Count heartbeats for one minute. (Set a timer or watch a clock as you count.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Normal resting heart rate:")]), _vm._v(" 100 to 120 beats per minute (adult cats); 130 to 140 beats per minute (kittens)")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("RESPIRATION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When a cat breathes, her chest expands and deflates. The best time to measure respiration is while your cat is asleep. Count inhale-exhale breaths for one minute. Watch her breathing pattern. Are breaths even and calm? (They should be.) If you notice her abdomen expanding instead of the chest, panting, gasping, or shallow breaths, call your vet immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Normal respiratory rate:")]), _vm._v(" 15 to 30 breaths per minute")]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 25")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Project: Start Your Cat Journal")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CAT JOURNAL IS A GREAT PLACE")]), _vm._v(" to collect memories and photographs of your cat. Amusing stories and silly pictures will remind you why you love your cat when your pet is trying your patience, and it can be a comfort when you’re feeling low.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your memory book can contain written passages, photo collages, or quick recollections. If you can draw, sketch with colored pencils. Paste in mementos of your travels together, even if your big “vacation” was an afternoon at a friend’s home or a car trip to the pet store to splurge on a new cat toy. Use your imagination to record not just the special times, but the everyday, too.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Journals come in a wide variety of styles and forms. Craft stores have fancy scrapbooks with large, removable pages. Bookstores, art supply stores, and office supply stores have dozens of blank books to choose from in a range of sizes, some with lined paper and others with plain paper. If you want to make entries every day, you might even consider a daybook calendar, which has a dated page or spread devoted to each day. Even a simple spiral notebook will do.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Creatively decorate the pages if you wish. Craft and scrapbooking stores have a huge selection of decorations, including decorative papers, stickers, rub-on transfers, stamps, and three-dimensional embellishments. Use colored pencils, markers, paints—whatever strikes your fancy. There are no rules. (For inspiration, check out art journaling books in the craft section of your local bookstore.)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0029-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "day23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 26")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Abyssinian")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONSIDERED A REVERED BREED")]), _vm._v(" in ancient Egypt, the Abyssinian, or Aby, has an angular body and curved wedge-shaped head. The Aby resembles cat mummies found in that region, as well as paintings and statues of the goddess Bastet. Abyssinia is modern-day Ethiopia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" The Abyssinian has a royal appearance—tall and muscular, with a shiny short coat that typically comes in one of three colors: a warm, orangey tone called “ruddy,” which can be as light as apricot; a deeper warm brown called “sorrel”; or a pinkish taupe called “fawn.” Whatever the color, it is ticked with one or more bands of shading—an early name for the breed in Great Britain was British Ticked—with the color at its deepest along the spine and at the tip of the tail. Occasionally, recessive tabby markings emerge.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Instead of the tabby "), _c('em', [_vm._v("M")]), _vm._v(", most Abyssinians have a vertical stripe of deep color above each eye. (Was this perhaps the inspiration for ancient Egyptians to shave off their own eyebrows when mourning the loss of a cat?) Unusually, Aby kittens are sometimes born with a dark coat that lightens as the cats mature.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Abys are generally playful but, perhaps yearning for their great sandbox of yore, do not always take to being confined as purely indoor cats. Some Abys carry a gene for PK deficiency, which causes anemia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" The first Abyssinian to come to the West was brought to Great Britain in 1868 by a soldier returning from the war in Abyssinia. He named the cat Zula. In 1909, British-born Abys were shown for the first time in an American cat show, in Boston, and were named Aluminium II and Salt, for their blue-ticked fur. It was not until 1935 that an Abyssinian was actually born in the United States; this landmark Aby was named Addis Ababa.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > When the Abyssinian was first brought to the West, its ticked markings led the breed to be called the Hare, Bunny, or Rabbit Cat.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0030-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Abyssinian")])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "day24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 27 + 28")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Kitty Talk: Your Cat’s First Ten Words")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VEN YOUR FIRST DAY TOGETHER")]), _vm._v(" is not too soon to speak with your cat. After all, if a foreigner joined your household, you would use simple words to find common ground. Although Kitty lacks the muscle coordination to speak your language, she can learn to understand your words, just as you can learn her body signals for what she is trying to express. Once she realizes there is a word for everything, she will pick up additional vocabulary more quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2z"
  }, [_vm._v("Begin with these essentials:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("1. Her name")]), _vm._v("—Say it often; coo it, whisper it, and singsong it. Watch her perk up when she hears it. Test her by calling from a distance—see if she comes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2. A name for you")]), _vm._v("—Use your actual name, a nickname, Mama, even Me. Point to her and say her name; point to yourself and say yours. Introduce other humans and animals this way, too.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("3. No")]), _vm._v("—The concept of "), _c('em', [_vm._v("no")]), _vm._v(" as meaning “stop” or “don’t,” and actually "), _c('em', [_vm._v("obeying")]), _vm._v(" it are different. You will need a lot of patience to get both aspects across. When your cat misbehaves, say, “[Name], no!” sharply while immediately interrupting or removing her from her wrongdoing. She will probably want to go back to what she did. Stop her as necessary, repeating, “No!” In time, she will catch on.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("4. Good")]), _vm._v("—Tell your cat she’s good if she licks you or initiates other positive things, and when she purrs. She will associate "), _c('em', [_vm._v("good")]), _vm._v(" with her pleasing you or feeling pleased herself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("5. Bad")]), _vm._v("—Only when your cat has begun to master "), _c('em', [_vm._v("good")]), _vm._v(" should "), _c('em', [_vm._v("bad")]), _vm._v(" be introduced: “No! Bad [name],” saying "), _c('em', [_vm._v("bad")]), _vm._v(" as witheringly as you can. Continue to use "), _c('em', [_vm._v("good")]), _vm._v(" in positive situations. She will begin to realize it’s her choice whether to be bad or good.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("6. Sit")]), _vm._v("—When your cat sits, say, “Good sit.” Also, try gently pressing her rump down into a sitting position, saying, “Sit.” If she sits and holds the position, say, “Good sit!” Ask her to sit while she is standing. Praise her when she obeys: “"), _c('em', [_vm._v("Good")]), _vm._v(" sit.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("7. Food")]), _vm._v("—When you feed your cat, hold up the can/package and say, “Food!” As she eats, say, “Good food.” Say, “Food!” to call her to eat. (You may wish to specify kinds of food, such as "), _c('em', [_vm._v("can")]), _vm._v(" versus "), _c('em', [_vm._v("crunchies")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("8. Bedtime")]), _vm._v("—When you go to bed, announce, “[Your name] bedtime.” Eventually, hearing “Bedtime!” may bring your pet running ahead of you to bed!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("9. Please")]), _vm._v(" and "), _c('strong', [_vm._v("10. Thank you")]), _vm._v("—Don’t laugh! These serve a purpose: Use "), _c('em', [_vm._v("please")]), _vm._v(" to signal a request. When she obeys, say "), _c('em', [_vm._v("thank you")]), _vm._v(", indicating she has accomplished your desire.")])]), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0032-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "day25"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 29")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Choosing the Right Litter Box")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITTER BOXES COME IN VARIOUS SHAPES")]), _vm._v(" and configurations, and your cat will surely let you know whether he is unimpressed with his “facilities.” (He may opt to take care of business elsewhere—one sign that the box is not his “type.”)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Put simply, the right box is the one that your cat will use. Before committing to a fancy box, make sure your cat will use it regularly. Place the new box near the old one, and let your cat take his time to make the transition (or not).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Plastic pan:")]), _vm._v(" As the most popular, this pan-style litter box comes in different sizes and depths. Shallow litter boxes are useful for older cats who may have trouble climbing into and out of standard litter boxes, as well as for disabled cats. These simple litter boxes are the easiest to clean because there is nothing to take apart, and you can use any type of litter with them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Sifting litter box:")]), _vm._v(" This variation consists of two stacking litter boxes and a sifting insert. You place one litter box inside the other, put the sifting insert in the top box, and then add clumping litter. To “scoop” the box, you lift out the sifting insert and, with it, the waste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Covered litter box:")]), _vm._v(" This box features a rigid cover that attaches securely to the base litter box, with an opening for your cat to enter and exit. Many of these boxes also have top or side vents to allow air circulation, and replaceable air filters to control odors. Covered litter boxes provide privacy for your cat, but some cats don’t like them, perhaps because they don’t like being enclosed or because they don’t like the concentrated odor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Decorative litter box:")]), _vm._v(" These litter boxes are disguised as furniture, such as an end table, cabinet, or chest. Usually, these function like a covered litter box but use a standard plastic litter box inside the chamber.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Self-scooping litter box:")]), _vm._v(" This litter box is electrically powered, and most use scoopable litter. The mechanical details of these systems vary, but the basic theory is the same. When your cat leaves the box, sensors activate a raking device that sifts litter and deposits wastes into a separate receptacle. There are even systems that use nonporous “litter,” water, and cleaning solutions and deposit wastes into your waste-water system.")])]), _c('div', {
    staticClass: "sidebarc"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "sidebartitle"
  }, [_vm._v("Litter Box Dos and Don’ts")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Do")]), _vm._v(" place the litter box in an area without heavy foot traffic or commotion.")])]), _c('p', {
    staticClass: "bulletlist"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("• "), _c('strong', [_vm._v("Do")]), _vm._v(" experiment with various types of litter (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day91"
    }
  }, [_vm._v("Day 106")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Do")]), _vm._v(" purchase the correct size and height litter box.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Do not")]), _vm._v(" scold your cat for missing the box. He will associate the box with your scolding and may avoid it.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Do not")]), _vm._v(" move the litter box to a different location; your cat will eliminate in the spot he knows regardless of whether the box exists.")])]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 30")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cloned Cats")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS CAN HAVE MORE THAN")]), _vm._v(" nine lives now, thanks to science. The first cloned cat, aptly named CC for Carbon Copy, was born out of a Texas A&M University research lab. While the university is responsible for a number of other cloned species, primarily farm animals such as pigs and goats, CC was the world’s first cloned companion animal. Even so, CC is not identical to her donor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here are some facts to help you understand how cat cloning works:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• CC’s clone material was produced using a nuclear transfer of Rainbow’s cells into Allie, a “surrogate mother.” CC’s fetus developed normally and was delivered by cesarean section.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cloning does not create an absolutely identical copy, and CC is certainly the proof of that. Her “mother,” Rainbow, a shorthaired calico, looks different from CC, who did not inherit the X chromosome that would give her the orange component of a calico’s coat. Therefore, CC is white with black tabby markings.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Even if CC were a calico, she would not have had the exact same markings as her molecular parent. Consider identical human twins born of a single cell that split. Their personalities are not the same, and they may look slightly different.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cloning by no means guarantees that the new animal will have the personality of the original source.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some criticize that playing with genetics is unethical. And some find the notion of scientifically reproducing pets self-indulgent, especially when viewed in the light of the continuing problem of cat overpopulation. As the process refines, it promises to remain controversial.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Given the available information about cloning, would you ever consider perpetuating your own kitty in this manner?")])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "day27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 31")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Oops! Missing the Litter Box")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR CAT IS TAKING CARE OF BUSINESS")]), _vm._v(" in all the wrong places—that is, everyplace except his litter box. Is he doing it on purpose? That depends on the type of bad aim he is displaying. (We’ll give Kitty the benefit of the doubt.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Spraying and marking")]), _vm._v(" are usually territorial responses, and the offending cat often is not neutered or spayed. (Altering a cat before these behaviors begin, usually before six months of age, may head off spraying and marking entirely.) If your male cat is intact, he will spray. Spraying also occurs in multicat households, or when there is a change in routine or environment that upsets the cat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How do you solve the spraying dilemma? Reduce competition in a multicat household by providing multitiered cat trees so every cat has his own perch. If your cat sprays in response to other cats he sees outdoors, block his view. If he habitually sprays or “marks” in a few spots in the house, treat those areas with a commercial cat repellent or mothballs wrapped in cheesecloth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Failing to use the litter box,")]), _vm._v(" and instead urinating right next to it or in another designated area, could point to a logistics issue. Where is the litter box located? If you place it in a high-traffic zone, Kitty may revert to a more private spot—box or not. What size and shape is the box? You may discover that the box requires kitty gymnastics to get in and out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Other reasons for missing the box, not associated with stress, include:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• The cat may prefer a different surface (litter).")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A “bully” cat in the household may prevent the cat from stepping near the litter.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Scolding her accidents or pain during urination may convince your cat that the litter box has bad karma.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Logistics: Cats need easy access to the box.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Older cats and kittens may forget where the litter box is located.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If Kitty keeps missing the box, a urinary infection may be the culprit. Talk to your vet about the behavior. A cat that experiences pain while urinating may associate that bad experience with the litter box and choose to “go” elsewhere.")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "day28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 32")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("A DIY Designer Collar")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OU CAN UPGRADE YOUR PET’S PLAIN")]), _vm._v(", nylon collar into a flattering neck piece with ribbon and a sewing machine. An abundance of inexpensive ribbon is available at fabric outlets and craft stores. Upgrading your kitty’s collar is so easy you’ll want to create collars for every holiday. These also make great kitty gifts for owners welcoming a new “baby” home. (Note: Always choose a cat collar with a breakaway feature; see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day85"
    }
  }, [_vm._v("Day 99")]), _vm._v(" for more on safe collars.)")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ribbon of choice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scissors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nylon collar, sized appropriately for your cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Matching thread and sewing machine or fabric glue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("Select the ribbon for the collar.")])]), _vm._v(" Take the collar with you to the craft store to make sure you select ribbon of the appropriate width. Do not cut the ribbon horizontally; avoid ribbon thicknesses that exceed the width of your collar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("Cut the ribbon to fit.")])]), _vm._v(" Unbuckle/unsnap the collar and lay it flat. Measure the ribbon against the collar and cut to the appropriate length.")]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0036-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("Fasten the ribbon to the collar.")])]), _vm._v(" Choose thread to match the ribbon colors, then sew along the edges of the ribbon. For thicker collars, you may sew a center stitch for reinforcement. Create a small stitch on both ends to polish the look. (Glueing the ribbon to the collar will not be as secure.)")]), _vm._v(" "), _c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0036-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 33")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("American Bobtail")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE AMERICAN BOBTAIL HAS A SHORT")]), _vm._v(", upright poof of a stubby tail. This fairly new, longhaired breed emerged in the 1960s as a spontaneous mutation, like Cymric (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 131")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" Because the American Bobtail’s ancestry is so mixed, all manner of colors are acceptable at cat shows. The important qualification for competing cats is the tail length. Like the “stumpy”-tailed Cymric, the cobby-bodied American Bobtail typically has a tail from 1 to 4 inches (2.5 to 10.2 cm) long. Occasionally, kittens may be born with either a full-length tail or none at all.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" A family named Sanders adopted a feral short-tailed cat wandering in Arizona and named him Yodie. He sired variously tailed kittens with the family’s Siamese cat, and when one of those cats mated it produced kittens with very short tails. The fur was on the short side, too, but a crossbreeding with Himalayans (see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 173")]), _vm._v(") and other breeds caused semi-longhaired kittens to become the standard for this mongrel breed, which became recognized by U.S. cat associations in 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0037-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("American Bobtail")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > The American Bobtail often grows an extra-thick double winter coat with lynxlike markings.")])]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 34 + 35")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("How to Name Your Cat")]), _vm._v(" "), _c('div', {
    staticClass: "blackquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("They say that the test of literary power is whether a man can write an inscription. I say, “Can he name a kitten?”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Samuel Butler (1835–1902)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAT’S IN A NAME")]), _vm._v("? Cats are often named for their physical attributes: coloring (Midnight, Snowball) and coat patterns (Boots, Patches). Some owners borrow names from favorite book or movie characters. There are a slew of cat-naming websites and pet name books to help you add more options to the name game.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Still stumped over what to call Kitty? Allow us to spark your imagination . . .")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Animal metaphors:")]), _vm._v(" Go for more unusual ones, such as Raven for an all-black cat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Unique characteristics:")]), _vm._v(" A calico, for example, might be called Harlequin or Columbine; or use Swash for a cat with a great plume of a tail.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Human names:")]), _vm._v(" Troll through baby-naming guides for ideas (e.g., you might call her Alva or Jennifer, if she is white, or Russell or Rupert if he is red), or honor a public figure or celebrity you admire. Commonsense tip: Avoid naming Kitty after friends or relatives who may not appreciate this tribute.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Themes:")]), _vm._v(" If you own more than one cat, consider giving them names that inherently go together. For example, a card-playing cat lover may name his pets Ace, Jack, and Queen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whatever you do, make sure you "), _c('strong', [_vm._v("select a name you wish to continue saying")]), _vm._v(" throughout the nine lives your cat will be there to answer to it. It should be distinctive, neither too close to another term you might use regularly in conversation nor so similar to another pet or family member’s name as to confuse your cat about whether he is being summoned. The latter is especially important if you have several cats. If you name one Aby Rudy and another Ruddy, they may both answer you when you call either name.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0038-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "day31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 36")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cat Carriers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("STURDY CAT CARRIER IS AN")]), _vm._v(" essential piece of equipment for the cat owner. You’ll need it to take Kitty to the vet, when you travel, and when you move. Cats should never be allowed to roam free in a car; they tend to like to curl up on the dashboard or under your feet, making for dangerous driving conditions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Several types of carriers are on the market, including ones made of cardboard, wire, cloth, and wicker. Your best bet is a carrier constructed of high-impact plastic. Plastic carriers feature a hinged door and are very easy to clean, unlike the other types. The small openings along the sides allow for air circulation while providing enough shelter and privacy that your cat will feel secure while you move him. Place a washable blanket, towel, or carrier pad in the bottom of the carrier for your cat’s comfort.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Train your cat to get used to the carrier (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 337")]), _vm._v(") so that having to go in it won’t be a traumatic experience. But accept that even the best-trained cat will be reluctant to enter the new carrier at first, so be prepared to put him in yourself. To do this, set the carrier on one end in another room, with the opening facing up.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pick up the cat by the scruff of his neck with one hand and support his bottom and hind legs with the other. Quickly but gently lower him into the carrier and close and latch the door, being careful not to close it on a paw, tail, or ear. Cats can move like lightning, so you’ll have to be quick about this. Slowly turn the carrier so the handle is on top.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you have multiple cats, each cat should have his own carrier. You wouldn’t want to find yourself caught in a situation, such as an evacuation, where you need to move all of your cats simultaneously and not be able to do so.")])]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 37")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Feline Flicks—Animated")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I tawt I taw a puddy tat. —Sylvester")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERYONE HAS HEARD OF")]), _vm._v(" Tom and Jerry, the dynamic cat-mouse duo that evolved into a Saturday morning cartoon staple. Then, there was the infamous Tweety Bird, always at war with archenemy Sylvester the cat. Tweety and Sylvester were Loony Toon stars, and Sylvester even had a brief career as a spokescat for 9Lives cat food.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But what about other animated cats that have graced the silver screen and boob tube over the years? Next time you’re in the mood for a cartoon cat flick, tune into one of these feline-lover classics:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Disney’s")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("Pinocchio")])]), _c('strong', [_vm._v(":")]), _vm._v(" The main character in this 1940 movie, Geppetto, has a pet cat named Figaro (voiced by Mel Blanc) that, unlike the cat in the original Collodi tale, is a friendly creature.")])]), _c('p', {
    staticClass: "bulletlist"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Alice in Wonderland:")])]), _vm._v(" There are many animated film versions of "), _c('em', [_vm._v("Alice in Wonderland")]), _vm._v(" (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 338")]), _vm._v("); Sterling Holloway voiced the Cheshire cat in Disney’s 1951 classic; in a 1999 movie produced for television, Whoopi Goldberg had that honor.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Lady and the Tramp:")])]), _vm._v(" The 1955 movie is about two dogs, but it also includes the unforgettable characters of Si and Am, voiced by singer Peggy Lee. Their “Siamese Cat Song,” as well as other musical numbers, was cowritten by Lee and songwriter Sonny Burke.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Gay Purr-ee:")])]), _vm._v(" The 1962 musical cartoon paired singer-actors Judy Garland and Robert Goulet (in his film debut) as the voices of the cats Mewsette and Jaune Tom, whose on-again, off-again romance is set against the backdrop of Paris. Hermione Gingold played Madame Rubens-Chatte. There are many delicious puns on an adult level, such as that legendary café, the Mewlon Rouge.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Aristocats:")])]), _vm._v(" This 1970 film concerns a pampered white cat named Duchess (voiced by Eva Gabor) whose wealthy owner dies, whereupon the butler desires to steal the inheritance left to her and her three kittens. An enterprising tawny tomcat named Thomas O’Malley (voiced by Phil Harris) comes to their aid. The cast includes many other feline characters. Scat Cat (voiced by Scatman Crothers) was modeled on Louis Armstrong.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Don Bluth’s")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("The Secret of NIMH")])]), _vm._v(" (1982), "), _c('em', [_c('strong', [_vm._v("An American Tail")])]), _vm._v(" (1986), "), _c('strong', [_vm._v("and")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("An American Tail: Fievel Goes West")])]), _vm._v(" (1991), and two additional American Tail sequels all include feline characters. Fievel is a mouse.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Cats Don’t Dance:")])]), _vm._v(" In this 1997 film, a small-town cat named Jimmy (Scott Bakula) goes to Hollywood dreaming to act and sing on the silver screen, only to be rivaled by a malicious child star who wants the spotlight for herself.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Puss in Boots")])]), _vm._v(": Lets not forget his appearance in the Shrek films, beginning with "), _c('em', [_c('strong', [_vm._v("Shrek 2")])]), _vm._v(" (voiced by Antonio Banderas, 2004).")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0041-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('a', {
    attrs: {
      "id": "day33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 38")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("The No-Fuss Guide to Administering Medication")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EELING SQUEAMISH ABOUT")]), _vm._v(" giving medication to Kitty? (My, what sharp teeth she has . . .) Ease the process with proper technique and the right tools for the job.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("USING FOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When serving with food, crush the pill and mix with a meaty moist canned food. Do not mix a crushed pill with an entire meal. If your cat doesn’t lick the bowl clean, she could miss out on a portion of the dosage. When administering whole pills, tuck the capsule into a semimoist food, soft cheese, or meat chunk. Feed your cat a tasty treat prior to giving her the masked pill to prime her taste buds for the second (medicated) helping.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("PILLS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ask your vet to show you how to administer pills by hand. You can use a pill pusher, or pill gun, to assist with the process.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Stabilize your cat by wrapping her in a towel so just her head peeks out. Otherwise, place her back against a surface, or squat on the ground and place her between your knees, so she cannot wriggle away as you feed her the pill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Using one hand, cup your hand over your cat’s head. Press your thumb on one side of the jaw (hinge) and your fingers on the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Tilt back Kitty’s head so she faces the ceiling. Her lower jaw will drop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Place the pill between the lower canine teeth and push down, but not too far—just over the hump of the tongue. Close and hold your cat’s mouth shut. She will naturally swallow. You may rub or blow on your cat’s nose to stimulate a lick, which results in a swallow. Finally, reward her with a tasty treat and plenty of praise.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("LIQUIDS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Feed your cat a tasty treat and praise her as you prepare the oral syringe or eyedropper. Withdraw the prescribed amount of medication. Stabilize your cat if she is fussy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Place the syringe or dropper tip into the mouth behind the canine teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Slowly administer the liquid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Hold your cat’s mouth closed and keep her head in a normal position to prevent gagging. If your cat spits out some of the medication, do not readminister a dose unless she spits out the entire portion.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0042-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("How to hold your cat’s head when administering pills")])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "day34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 39")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("“Green” Your Cat’s Play with Eco-Toys")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON’T FORGET TO INCLUDE")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITTY’S")]), _vm._v(" interests as you “go green” at home. These objects can be recycled into terrific cat toys.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Full-size plastic drinking straws, especially the flexible kind. They make a neat popping sound when batted about, and can be carried in your pet’s mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Rinsed and crumpled paper cups (don’t use plastic or Styrofoam, which could crack or chip).")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Large empty thread spools. Remove the paper labels before giving to your cat. (Don’t give your cat small spools or bobbins that can be swallowed.)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• The protective paper strip removed from a large self-stick envelope. Tie into a knot or two to add more dimension.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Empty paper grocery or shopping bags, standing open on one side. Be sure to cut off and discard any handles.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cat-size or larger empty cardboard cartons. Remove any tape, foam pellets, Bubble Wrap, or sticky labels.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A colorful blow-in card from a magazine, folded and twisted into a thin strip. Some cats go wild over batting these around.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• An empty childproof medicine bottle, well rinsed and dried, into which you have place a few pieces of dried cat food before recapping—instant, safe rattle toy!")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• An empty toilet paper roll. Amuse your cat by peeking through it at each other as if it were a telescope, as well as letting Kitty roll it around.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Not quite recycling but certainly green: See if your cat will accept a fresh string bean, celery stick, or carrot stick as a carry-and-bat toy.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• An old sweater, towel, or blanket past all hope for human use makes a cozy snoozing place that will remind Kitty of you.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "day35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 40")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("American Curl")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS UNUSUAL BREED IS")]), _vm._v(" A newbie in the cat world—it’s less than thirty years old. Its story is equally modern: Two strays meet, fall in love (cat love, anyway), and start a family.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" Because just one parent needs to have curled ears for the gene to pass along, several varieties of American Curl already exist—longhaired and shorthaired. Both kinds have silky fur without any undercoat, and a thick tail. The roundness of the ears varies from cat to cat; an ear that doesn’t simply curve but folds all the way back is considered a fault at cat shows.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" The American Curl originated when two stray kittens were taken in by a California couple named Ruga, in 1981. One, a black female they named Shulasmith, had backward-curling ears, and when she gave birth to four kittens, two had inherited their mama’s curled ears.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Shulasmith and some of her offspring were shown at a California cat show in 1983. Descendants continued to display this characteristic, and in 1985 the American Curl became an official breed.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > The ears of an American Curl furl backward tightly a few days after birth, not taking on their full, softer curl until the kitten is about four months old.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0044-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("American Curl")])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "day36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 41 + 42")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Spoil Your Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HO DESERVES IT MORE")]), _vm._v("? Kitty is your baby, the best listener, and she just loves people (really)—and especially you, of course. So why not spoil her? You don’t need a special occasion to treat your cat right. Besides, you will follow a long line of cat worshippers. Consider the highly regarded ancient Egypt cat goddess, Bastet, associated with fertility, motherhood, grace, and beauty. (If your cat could read, she’d be giving you a feline dose of “Told you so.”)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Dedicate a piece of furniture.")])]), _vm._v(" That’s right. Make sure her lounger has a view of the outdoors, and it’s okay to adorn that chair with a monogrammed kitty pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Give her a plant.")])]), _vm._v(" Just make sure it’s catnip or cat grass. If catnip were a vice, cats would be addicts. (Moderation is the key.)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Treat her to a massage.")])]), _vm._v(" You know her love-me spots. (Sometimes, they’re strange, like between the toes.)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Break out the china.")])]), _vm._v(" It’s mealtime, but you can make it special by serving her food in special bowls. Garnish her ordinary dinner with some smelly canned tuna. (Smell = good.)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('em', [_c('strong', [_vm._v("Provide a window seat.")])]), _vm._v(" Window benches give cats a comfortable perch with a view.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The ultimate: "), _c('em', [_c('strong', [_vm._v("Create a cat room.")])]), _vm._v(" Call it the nursery, or the cat den, but whatever you call it the room is equipped with every kitty pleasure possible. Fountain? Check. Multiple scratching posts? Got it. Kitty hideout and built-in cat stairs so the pets can perch at leisure? Of course. Toys are a given. If you have the luxury of an extra bedroom or space in the basement, this is your opportunity to deck the space just for Kitty.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0045-01.jpg"
    }
  })])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "day37"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 43")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Purring")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ABILITY TO PURR IS ONE OF")]), _vm._v(" your cat’s most distinctive features, but also one of the most puzzling. Why do cats purr, anyway? There are several theories, and the question has been contemplated for centuries. Some say the lulling noise is caused by blood vessels; others point to bone vibration, or even a special purring organ (there is no such thing).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Researchers now believe purring is caused when a cat’s brain sends signals to muscles in the larynx, which cause the glottis to vibrate. Passing air causes vibrations that result in the purring sound. The purr sounds continuous because it happens when cats are inhaling and exhaling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The purrs of some cats can be heard across the room; others are so quiet that you know your cat is purring only by feeling the vibration. Cats purr when they are contented, much like humans smile or dogs wag their tails. But many people don’t realize that cats also might purr when nervous, frightened, or injured. Just because a cat is purring, don’t assume he’s happy.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is speculation that the vibration frequency of a cat’s purr stimulates muscles and bones and may promote healing in both cats and humans.")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "day38"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 44")])]), _c('a', {
    attrs: {
      "id": "day38"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("The Idiomatic Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AT GOT YOUR TONGUE")]), _vm._v("? Cats have been the source for many a metaphoric expression and idiomatic phrase. Here are some of them:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• “It’s the cat’s pajamas” and “It’s the cat’s whiskers” essentially mean the same thing: just right or superlative.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• When Australians have eaten a large meal, they say they are full “up to pussy’s bow.”")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Whereas Americans say they are “sick as a dog,” when ill, in England they would be “sick as a cat.”")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• To “play cat and mouse” describes two individuals who deliberately pursue and evade each other.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• To “let the cat out of the bag” is to accidentally disclose a secret.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• To be “in the catbird seat” is to be in a position of prominence, such as to obtain a plum promotion at work.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• To “have kittens” is to be upset; a cousin of this expression is to “have a cow.”")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• To “put a cat among the pigeons” is to introduce an inflammatory comment or person into a situation.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• To look like “the cat that just ate the canary” is to behave smugly, whereas to “behave kittenishly” is to be coy.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• In French, to “disappear like a cat” is to leave without paying.")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day38"
    }
  }), _c('a', {
    attrs: {
      "id": "day39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 45")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Does Kitty Need Pet Health Insurance?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR CAT’S MEDICAL BILLS")]), _vm._v(" can really add up, and most owners are not prepared to cover the high cost of veterinary care, especially when emergency procedures are necessary. Because pet insurance is a topic usually discussed when your cat is a kitten, it’s easy to discount the importance of coverage and justify that “Our cat is perfectly healthy!” But even routine costs, from spaying to deworming and vaccinations, can tax your wallet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Also, accidents happen. Kittens are more susceptible to disease and nutritional issues than adults; aging cats may need cancer treatment or expensive medication. Pet health insurance works similar to insurance for people. There are various insurance packages and levels of coverage to accommodate cats’ needs and owners’ budgets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Monthly premiums are relatively low, but they can vary widely depending on the plan you choose as well as your cat’s age, medical history, and living situation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Indoor cats are less likely to get hurt, so rates may be lower. Also, you can purchase pet insurance for a lower premium if you invest in coverage right away. If your cat develops pre-existing conditions before you purchase pet insurance, you’ll pay more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Plans range from accident-only to premium plans that include everything from vaccines and wellness exams to chemotherapy and complex surgeries. A few things that are not usually covered are congenital, hereditary, or pre-existing conditions. Deductibles and monthly plans will vary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before you buy pet health insurance, find out exactly which conditions are covered, review pricing schedules and limits, and discuss the plan with your veterinarian to make sure insurance will cover most common problems. He or she can also refer you to reputable providers and weigh in on the integrity of insurers.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0047-01.jpg"
    }
  })])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "day40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 46")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Gifts for Cat Lovers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MANY CAT LOVERS ARE PASSIONATE")]), _vm._v(" about collecting images of their own pet’s breed . . . or catthemed anything. Here are some ideas to make any feline fancier purr with pleasure:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cat-print fabric or ribbon, or cat-shaped buttons, for someone who sews")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• An embroidery or latch-hook kit depicting a cat who resembles the recipient’s pet, if the person likes to work from kits")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cat-shaped cookie-cutters or cake molds, for bakers")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Decorative home items, such as kitchen-ware or cat-print linens")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A photograph of the person’s cat, enlarged and decoratively framed (or a series of photos of the cat in various poses, in a grouped arrangement). This is quite a touching gift for cat owners who haven’t taken the time themselves to photograph Kitty.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cat-motif clothing or accessories, such as pajamas, socks, or jewelry")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cat-motif playing cards or board games")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cat-motif stationery, address books, mousepads, or posters")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A book about cats. Look for antique editions.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Videos/DVDs of live-action or cartoon films for a cat’s viewing pleasure, such as a nature film featuring birds")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Holiday tree ornaments depicting cats, strings of cat-shaped lights, or Halloween-theme black cats")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A subscription to a cat fancier’s magazine would be enjoyed all year by someone who does not already subscribe.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0048-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "day41"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 47")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("American Shorthair")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE PILGRIMS’ CATS WERE")]), _vm._v(" American Shorthairs, and they are hardy house cats that spent 350 years in the United States before being named an official breed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" Not as round of face or as husky as its British cousin but still broad cheeked and sturdy, the American Shorthair comes in every color as well as the several tabby varieties and calico. The most famous coloring is the deeply striped classic tabby, with a clear M on the forehead. Its fur is indeed short and quite dense, and it tends to grow more thickly in cooler months, perhaps thanks to this breed’s origins as a pioneer cat that spent its days outdoors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" Also known as Domestic Shorthair, this breed was brought over from England by settlers who date back to the original Pilgrims, in 1620. Journeys of the British Shorthair to America continued for centuries, resulting in the first American Shorthair show cat’s actually being a British-born cat named Belle of Bradford, back in 1900, brought by Jane Cathcart. In 1904, she submitted to a show an American-born nonpedigreed shorthair by the name of Buster Brown. But even in the twentieth century, such cats were not respected as more than an everyday house pet, condescendingly allowed to compete in an anything-goes pet category but not as their own breed. Today, they are an official breed.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > The American Shorthair is reputed to be an especially good hunter, perhaps dating from its hardscrabble survival skills learned while living among the nation’s early European settlers.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0049-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("American Shorthair")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "day42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 48 + 49")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Story: Toilet Training Lessons from the Dog")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I "), _c('span', {
    staticClass: "small"
  }, [_vm._v("GOT MY FIRST CAT")]), _vm._v(" when I was thirty-two years old. The cat antics staged at my home provide a lifetime of entertainment. The best is when my dog, Emma, and cat, Ernie, teach each other shenanigans. You can practically detect their scheming, the way they flee off together. Then the next thing you know, well . . . it can’t be good.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Emma has always preferred drinking from the toilet bowl rather than the dog-appropriate dish I place in her eating spot. I refresh the water regularly. Emma doesn’t care. She heads straight to the bathroom, and proceeds to what she believes is her personal drinking fountain.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My cat Ernie had only been with me for a week when Emma became his teacher. Her orientation started in the bathroom. I caught Emma lapping up toilet water and Ernie perched on the tank, peering over into the bowl. He was studying. I left, somewhat amused.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A few minutes later, the two were still “busy,” so I checked in on them. Emma had retreated to the bedroom for a nap, but Ernie was circling the toilet bowl, walking the seat like a balance beam. He was trying to figure out how to get a sip of the cold water without getting his feet wet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ernie was completely oblivious to my watching. He straddled the seat, craning his neck to reach for the cool water. No luck. He slipped, his body like a hammock with front and back paws clinging to either side of the bowl. He leaped away, recovering from the awkward position, but didn’t give up.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He tried to copy Emma’s move, reaching in from the floor to the bowl, but Ernie’s tongue just wasn’t long enough. Frustrated, I could tell, Ernie made his final attempt. He stood on the bowl and eased his front paws inside, resting them just above the water line. Success! Ernie got the drink he’d been waiting for.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('a', {
    attrs: {
      "id": "day43"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 50")])]), _c('a', {
    attrs: {
      "id": "day43"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cat Calls and Other Sounds")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOWING IS THE SOUND")]), _vm._v(" most commonly associated with cats. Ask any kindergartener what sound a cat makes, and her answer will be “meow!” Meows usually mean “pay attention to me” and are employed when your cat wants something (such as a taste of your tuna sandwich) or just to say “hello.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What about all those other sounds cats make?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Hissing")]), _vm._v(" is a defensive sound, usually accompanied by laid-back ears and sometimes by hair standing on end.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Growling")]), _vm._v(" sometimes accompanies hissing, and is a sign of displeasure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Chattering")]), _vm._v(" is a rapid clacking of the teeth sometimes heard when a cat is ready to pounce on prey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Low-pitched yowling or crying")]), _vm._v(" is a sign of discomfort or frustration, not necessarily pain, as when a cat who doesn’t like to travel is put in her crate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Caterwauling")]), _vm._v(" is loud yowling exchanged between two cats that are preparing to fight, and is heard more often in outdoor tomcats in the mating season.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Screaming")]), _vm._v(" is a sign of pain and sometimes associated with sex.")])]), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('a', {
    attrs: {
      "id": "day43"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "day43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0051-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "day44"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 51")])]), _c('a', {
    attrs: {
      "id": "day44"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("When Is a Cat Not a Cat?")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME WORDS SOUND AS IF THEY")]), _vm._v(" have something to do with cats, when actually they have nothing to do with Kitty.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("cat burglar")]), _vm._v("—a robber who enters through an upper story")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("catacomb")]), _vm._v("—an underground cemetery")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("catalepsy")]), _vm._v("—a trancelike state")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("catamaran")]), _vm._v("—a sailboat with twin hulls")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("cataphoric")]), _vm._v("—a word or phrase that refers to another word or phrase that follows it")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("cataract")]), _vm._v("—a waterfall over a precipice; an eye condition")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("catbird")]), _vm._v("—a “meowing” American songbird related to the mockingbird")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("catfish")]), _vm._v("—a freshwater fish with long barbells resembling whiskers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("catgut")]), _vm._v("—the strings of a musical instrument or bow, actually made from the innards of farm animals such as sheep")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("cathead")]), _vm._v("—a projection on a ship to which an anchor is attached")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("cathouse")]), _vm._v("—a bordello")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("cat-lap")]), _vm._v("—British slang for unappetizing food or drink")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("cat’s eye")]), _vm._v(" (also "), _c('em', [_vm._v("katzenauge")]), _vm._v(" [German])—British for a light-reflective stud along a roadway")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("catwalk")]), _vm._v("—a narrow path")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("kitty")]), _vm._v("—a pool of collected money, as in poker")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("kitty-cornered")]), _vm._v("—located on the diagonal (also called "), _c('em', [_vm._v("catty-cornered")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("langues-de-chats")]), _vm._v("—delicate cookies piped or molded into spatulate strips (literally, “cats’ tongues”)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("tabby")]), _vm._v("—a kind of cement")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0052-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "day45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 52")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Treat and Prevent Hairballs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL CATS—EXCEPT, PERHAPS, THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHYNX")]), _vm._v("—experience hairballs. The culprit: their prickly tongue, which forces any ingested hair down a one-way street into their stomach, where the cat’s body finally recognizes that it is not food and wants to get rid of it. "), _c('em', [_vm._v("Ccchhhhhwwwwuuuh!")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("The typical cat regurgitation of a hairball involves two spurts—one a little drab of liquid, and the other, a wad of hair in a larger puddle of liquid. As long as the wad has come out, your cat is fine. She will not have lost her appetite, and you do not have to give her any medicine or take her to the vet. Stepping up your grooming of her should prevent most future problems (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 218")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But if hairballs seem to be a regular occurrence in your home, despite regular grooming, and especially if your cat tends to be constipated (look for hard, small stools), she may need a touch more lubricant and/or roughage added to her diet. This can take the form of:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A little bit of vegetable oil (such as olive oil) or butter, mixed into her food or as a separate supplement")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A commercially prepared hairball preventive that often comes as a gel in a tube or as crystals that you can sprinkle on food (check pet supply stores). If the product contains mineral oil, be sure to give Kitty a vitamin supplement, because mineral oil can deplete her body of vitamin A.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Hairball–remedy food (check cat food labels)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A small amount (such as a half spoonful) of finely grated or cooked, pureed raw carrot or cooked, pureed sweet potato, pumpkin, or winter squash. For convenience, look for a jarred baby food version of this that is pure vegetable without any added salt or garlic; you only need a little bit at a time, so freeze it in spoonful-size dabs on a sheet of waxed paper and then store in an airtight container in the freezer (thaw before giving to Kitty).")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Cat grass (wheatgrass or other grass; avoid giving Kitty alfalfa or other sprouts, however)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A pinch of ground psyllium mixed into the cat’s food (check natural food stores for brands that do not contain citrus flavoring)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If your cat has stopped eating and is severely constipated, she may have developed a hairball that has gotten too stuck to vomit out. This is an urgent situation and requires a vet’s attention. In extreme cases, such hairballs may even require surgical removal. Obviously, prevention is key to keeping Kitty in tip-top form, particularly if she has long fur.")]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 53")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Chocolate-Point Cat Cookies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESE CHOCOLATE-POINT")]), _vm._v(", orange-flavored Siamese cookies really do have chocolate points! Impress all your cat-loving friends with this easily decorated sugar cookie. If possible, use a cutter of a slim cat shown in profile, so you have clearly definable areas for the tail, paws, ears, and muzzle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Makes about 6 dozen 3-inch (7.6 cm) cookies; count will vary, depending on the size and shape of your cookie cutter.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "h5a"
  }, [_c('em', [_c('strong', [_vm._v("Cookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 3/4 cups (397 g) unsalted butter, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("6 tablespoons (75 g) granulated sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1/2 cup (60 g) confectioners’ sugar, sifted")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 large egg")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons (10 ml) orange extract or orange-flavored liqueur, such as Grand Marnier")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 cups + 2 tablespoons (266 g) sifted all-purpose flour, divided")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1/2 teaspoon (2.3 g) baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1/2 teaspoon (1.5 g) cream of tartar")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 tablespoon (6 g) (pat dry) freshly grated orange zest or dried ground orange peel")]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_c('em', [_c('strong', [_vm._v("Chocolate Glaze")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 (1-ounce [28 g]) square semisweet baking chocolate")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon (4 g) vegetable shortening")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("To make the cookies:")])]), _vm._v(" In a large mixing bowl, using an electric mixer on medium speed, cream the butter with both sugars, then beat in the egg and orange extract.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Add 1 cup (125 g) of the flour, the baking soda, and the cream of tartar; beat on low speed just until blended.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Beat in the remaining 1 cup and 2 tablespoons (141 g) flour and the orange zest.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Knead with just a few squeezes, and then press the dough into three disks, using your hands. Wrap each disk in waxed or parchment paper and place in the refrigerator for 3 hours or overnight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Preheat the oven to 375°F (190°C, or gas mark 5). Have ready two ungreased baking sheets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" Dust two sheets of waxed paper well with flour. Remove one disk from the refrigerator and roll out the dough 1/8 inch (3 mm) thick between the prepared papers. Use a cat-shaped cookie cutter to cut as many cats as you can without re-rolling the dough. (Dipping the cutter into flour helps it release the dough.) Carefully transfer the cookies to a cookie sheet, leaving about V inch (1.3 cm) between the cats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" Between sheets of freshly floured waxed paper, reroll the scraps and start another disk of dough if necessary, to fill the two baking sheets with cats. (While the cookies bake, continue to cut out more dough, lightly placing the cutouts on the waxed paper in which you had chilled the dough, until the pans are ready for them.)")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Bake the cut cookies for about 7 minutes, or until lightly browned. Let cool for a few minutes before removing from the pan with a sharp-edged spatula. Place on a cooling rack and transfer to fresh waxed paper sheets once completely cooled.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("9.")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("To make the glaze:")])]), _vm._v(" In the top of a double boiler or small stainless-steel pan set over but not touching simmering water, melt the chocolate and shortening.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("10.")]), _vm._v(" Using a clean pointed-tip brush, the tip of a small spoon, or the end of a chopstick, paint the chocolate glaze onto only the cookies’ ears, muzzle, tail, and paws, keeping the glaze on the top surface of the cookies. Reheat the chocolate if necessary to keep it smooth and flowing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("11.")]), _vm._v(" Let the cookies dry completely in a single layer in a cool place before stacking in an airtight container. They keep for about a week at cool room temperature or in the fridge, or can be frozen for up to two months.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0055-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "day47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 54")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("American Wirehair")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE AN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERICAN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORTHAIR")]), _vm._v(" (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day41"
    }
  }, [_vm._v("Day 47")]), _vm._v(") and cross it with another American Shorthair, and . . . surprise! The result is a male cat with a coarse, crimped coat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" The first few generations of American Wirehair were bicolor, with red and white fur, but now any color shared by the American Shorthair (see "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day41"
    }
  }, [_vm._v("Day 47")]), _vm._v(") can be found in this breed. Breeders have worked to produce evenly crimped fur, which should form ringlets right to its tips, as well as a more compact body than the first long-legged ancestors. Wirehair kittens are born with fur that is already tightly curled.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Because the wirehair characteristic is carried by a recessive gene, matings of cats even of this same breed can produce kittens with normal fur and, on the flip side, excessive inbreeding can cause respiratory problems in offspring; as a result, healthy, genuine Wirehairs are still relatively rare.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" The first American Wirehair was bred, by accident, on a New York farm in 1966. The standard shorthaired breed spontaneously mutated to produce a unique coat. This rough-furred male, named Adam, was mated with one of his soft-haired littermates, named Tip-Top, and she produced two wirehaired kittens. Descendants of one, Amy, bore the numerous litters that have formed the basis of this new breed. Virtually every American Wirehair can be traced back to this special family. The breed was recognized in the United States in 1977.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > Even the whiskers of the American Wirehair are crimped!")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0056-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("American Wirehair")])]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 55 + 56")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Welcome Home, Kitty! Prepare a Shower Basket")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR FRIEND IS EXPECTING")]), _vm._v("—a cat, that is—and you want to surprise her with a cache of cute kitty gear. First, purchase a basket or plastic storage container you can convert into a bed. Line the container with a cuddly towel or fleece blanket. This will double as a gift basket to hold the booty, and a cozy bed where the new kitten can snooze.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now for the fun part: filling the basket with delightful and useful cat goods. Here are some items that new cat owners (and their kitties) will appreciate:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A catnip-stuffed toy")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A laser pen (for the human); kittens get a kick out of chasing after the darting red light")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A small grooming comb designed for kittens")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Containers of tasty canned kitten food; you may inquire, ever so stealthily, what the kitten is eating so you purchase the correct brand")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A decorative collar and matching leash")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A box of litter (it runs out quickly)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A special book about cat care that you found helpful while raising your own kitten")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0057-01.jpg"
    }
  })])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "day49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 57")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cleaning Up “Accidents”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMETIMES A CAT MAY SPRAY")]), _vm._v(" or “mark” an area to send a message: “My litter box needs cleaning!” Other times, kneading a squishy surface, such as a blanket or a favorite object of yours, may trigger a little too much excitement: “This feels soooo good . . . oops!” Or your cat may be signaling you that she has a urinary tract infection or other condition that doesn’t feel quite right down there: “Get me to a vet, please!”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you get to know your pet, you will recognize which behavioral pattern is occurring. But what should you do about removing the evidence?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If the affected surface is washable, your best bet is white distilled vinegar. Pluck or scrape off any solids first, using a dry paper towel. If the soiled item is a fabric that can be machine washed, use about a cup of vinegar to start in an entire washing cycle and let it run all the way to spin dry, then use another cupful of vinegar for a second cycle, following up with a complete wash and rinse using your usual detergent.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If hand washing, do the same on a smaller scale, using either detergent or castile-based soap after the second vinegar wash, and rinsing well. Hard surfaces, such as tile or wooden flooring, can be washed with an appropriate product for the surface material once some vinegar has removed and neutralized your pet’s waste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Upholstery or carpets or dry-clean-only clothing can be dabbed carefully with vinegar and then rinsed with water, using damp rags or paper towels. Never rub in solid wastes. It is often easier to remove solids by letting them dry and then snapping or even vacuuming them off. A thin putty knife can also be dedicated to this purpose. When in doubt, test the effect of vinegar on an unobtrusive section of the soiled item, using just a few drops on a cotton swab. An alternative to vinegar is to sprinkle the affected area heavily with baking soda, let it rest for thirty minutes to absorb the odor, then vacuum up the powder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If any trace of a scent remains, your cat may return to the spot as a repeat offender. Add a drop of peppermint or lavender oil to the last rinse to mask any faint odor that remains and provide a pleasant, catnip-family fragrance that he may be loath to ruin with his own stinky contributions. Resist using any commercial cleansers that will leave behind an undesirable presence of their own (and which could be toxic to Kitty).")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("The best prevention of future accidents is to remove the temptation to repeat them, be it by covering a targeted soft chair with a firmer slipcover or by placing visitors’ personal things in a closed cupboard . . . or making sure your uncomfortable little one has her elimination issue checked by a medical professional as soon as possible. (See ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Days 122")]), _vm._v(" and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("311")]), _vm._v(" to learn more about urinary disorders, and "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 353")]), _vm._v(" for the lowdown on intestinal diseases.)")]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day50"
    }
  }), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 58")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cat Games for Humans")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS AREN’T THE ONLY ONES")]), _vm._v(" who play cat games! These games keep animal lovers of all ages occupied, indoors and out.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Cat’s cradle")]), _vm._v("—In this game string is woven upon the hands of one player and then deftly passed back and forth when a second (or more) enters the game.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Cat tarot")]), _vm._v("—Not a game to some, but serious divination, Tarot is done with a deck of cards featuring symbolic figures and numbers. These decks date back to the early fifteenth century.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Cat parlor games")]), _vm._v("—Parlor games involve spoken-aloud challenges, acted-out charades, or pen-and-paper puzzlers. One of the speaking games is “The Minister’s Cat,” which works through the alphabet. The first player says something like, “The minister’s cat is an attractive cat.” The next person repeats this, adding another "), _c('em', [_vm._v("a")]), _vm._v(" adjective, such as, “The minister’s cat is an adventurous, attractive cat,” and so it goes around the room until someone stumbles and has to drop out. Then the letter "), _c('em', [_vm._v("b")]), _vm._v(" begins, and as long as there are sufficient players the game could advance all the way to the letter "), _c('em', [_vm._v("z")]), _vm._v("! Another popular game in Victorian times was “Poor Pussy”: A player had to stroke another’s head and say mournfully, “Poor Pussy”—and anyone who laughed was out of the game.")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "day51"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 59")])]), _c('a', {
    attrs: {
      "id": "day51"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Why Is My Cat Eating Dirt?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS EXPLORE WITH THEIR PAWS")]), _vm._v(" and mouths—they taste and see the world for themselves. It’s normal for your cat to chew on bits of cloth, eat paper, or take in a mouthful of dirt from time to time. But there are cases when a cat’s nibbling habits are cause for concern. A cat that eats dirt or litter may be seeking trace minerals such as iron, a sign of anemia. (If your cat chews on cloth, stop the habit by keeping her busy with other toys. If swallowed, it will obstruct the cat’s bowel.)")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "day51"
    }
  }, [_vm._v("Anemia is most prevalent in cats that roam in the spring and summer, increasing their risk for flea infestation. Proper flea prevention (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day69"
    }
  }, [_vm._v("Day 80")]), _vm._v(") is important for preventing parasites (fleas, ticks, lice) from spreading harmful organisms to your cat, which can cause feline infectious anemia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Other symptoms of anemia are weakness and jaundice. If you suspect anemia, see your vet immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your cat’s oral fixation may just signal the urge to “explore.” Here are some tips to modify the behavior:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Secure targeted items, such as blankets, houseplants, and electric cords.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Entertain your cat with interactive toys. Plant catnip indoors to lure your cat to this “houseplant” instead. Cats chew when they are bored, so keep them busy.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Consult with your vet to determine whether dietary changes are necessary to fulfill your cat’s nutrition needs.")]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 60")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Catnip Blanket")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS EASY-CARE FLEECE")]), _vm._v(" sitting surface has a little something extra—not only is it comfy but it’s also laced with catnip, to give Kitty extra-sweet dreams and perhaps help calm an anxious traveler. Launder with a gentle detergent and tumble dry on low; once your pet remembers the blanket contained catnip, she will continue to enjoy it even after the scent has faded or washed away.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Seek out paw- or cat-print fleece at your craft store or at online quilter’s fabric sites.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 pieces polyester quilt batting, 18 inches x 22 inches (45.7 x 55.9 cm) for blanket, or 1 inch (2.5 cm) shorter and narrower than your cat carrier’s base")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 pieces fleece, the same dimensions as the batting")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons (4 g) dried catnip")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Straight pins")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scissors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Coordinating or contrasting acrylic yarn and tapestry needle")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Place a piece of batting atop the wrong side of one piece of fleece, sprinkle the batting side with the catnip, then cover with the other piece of batting and finally with the second piece of fleece, wrong side against the batting. Pin all around and trim away any uneven edges.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Using the yarn and needle, blanket-stitch around the entire perimeter of the blanket, concealing any ends of the yarn inside the blanket.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0060-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _c('a', {
    attrs: {
      "id": "day53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 61")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Balinese (Javanese)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REED NAMES CAN BE DECEIVING")]), _vm._v(". Although it’s true that the Siamese cat originated in Siam, the Balinese cat’s roots are in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" Unlike most other longhairs, these supersleek cats have no ruff. Their fur is called “erminelike” for its softness. Like their Asian ancestors, they are born white before they develop colorpoint coloring. They have blue eyes and an exotic bone structure. But, in contrast to their shorthaired cousins, they are generally far less vocal!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" In 1955, in two separate instances, one on the West Coast and the other on the East, two longhaired Siamese (genetic mutations of the normally shorthaired breed) were brought together by breeders to produce kittens that shared the longhaired characteristic. At first, the fuzzy exotics were simply called Longhaired Siamese, and were presented by that name at a U.S. cat show in 1961, but breeder Helen Smith decided to call such fluidly graceful creatures Balinese, after the dancers of Bali.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The name stuck, and British recognition of the breed followed two decades later. Interestingly, cat shows in Great Britain accept more color varieties for this breed than do shows in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is where the term "), _c('em', [_vm._v("Javanese")]), _vm._v(" enters the picture. The name simply means a Balinese with a solid-color coat.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > If a Balinese is mated with a Siamese, the result will be shorthaired kittens. But if these kittens are mated with a Balinese, voilà—that third generation will again have long hair!")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0061-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Balinese")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _c('a', {
    attrs: {
      "id": "day54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 62 + 63")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Warming Up Miss Independent")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE DOESN’T MEAN TO GIVE YOU")]), _vm._v(" the cold shoulder, but she really prefers not to sit on your lap and rarely does Kitty brush up against your leg, or give you that swooning gaze. Don’t mistake her meow for, “Mommy me! Mommy me!” Nope. Not happening at your house. Although you understand your cat needs personal space (don’t we all?), you sometimes wish she would check that aloof attitude in her kitty condo and curl up with you once in a while.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can’t change your cat’s personality. And it’s important to note that not all cats are underattached or dismissive; some are lovers—Velcro cats, we’ll call them. So the excuse that Kitty’s disinterest in you is a “cat thing” just doesn’t hold water. There are some techniques you can employ to encourage your cat to warm up to you. This is by no means a directive to force Miss Independent into cuddling with you. (As you know, she’ll do exactly what she pleases.) However, these tips will help her associate you with a reward, so she’ll come around and aim to please you more often.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Offer your cat small meals throughout the day so she associates your presence with food.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• While feeding your cat, speak to her in a soothing tone. Praise her. Tell her she’s the diva of the house, that she’s beautiful. (Cats understand this language—or at least it seems they do.)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Find your cat’s favorite spot. Sit there, on the floor, and encourage her to come to you.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Don’t wait for her to jump into your lap. Instead, invite her to play a game: get out the laser pen and have some fun! She’ll connect playtime and friendship with you. She may even brush up against your leg if she wants to play another round.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Resist the urge to pick up your cat if she is not cooperative.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Do not try to chase her down or force quality time. This will only make her stray from you.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Be patient. Building relationships takes time, and your cat will eventually trust you for more than just a square meal.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There may be deeper reasons why your cat is not interested in human contact. Adopted pets might have a hurtful past; they associate humans with unpleasant experiences from previous owners or time on the streets, if the cat was a stray. Give her time to trust you. Use food to encourage her to come to you so she will associate you with good things. Over time, she will recognize you as her caring owner.")])])]), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0063-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "day55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 64")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Contending with Clawing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR CAT’S CLAWS CAN TAKE")]), _vm._v(" a toll on furniture, carpet, family heirlooms, hand-knitted throws, and just about any other object that your cat envisions as a handy scratching post. No cat owner’s home goes scratch-free, though some cats claw more than others do. Even declawed cats sometimes go through the motions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Clawing is a natural action for cats. Their claws grow in layers, and clawing is how they shed the old claw sheaths and expose the new claws underneath. Cats also claw to mark their territory and to get a good stretch. You can no more stop a cat from clawing than you can stop her from grooming herself.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("However, you can control clawing by providing alternative clawing surfaces and doing some basic training. A good scratching post and scratching box (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day4"
    }
  }, [_vm._v("Day 4")]), _vm._v(") are essential. Make the post or box attractive to your cat by spraying them with pheromones (see "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day76"
    }
  }, [_vm._v("Day 88")]), _vm._v(") and/or rubbing them with catnip. Praise her when she uses her scratching post or box.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Commercial sprays may help keep your cat from clawing unapproved surfaces. These usually contain clove oil, citrus oils, or other strong-smelling substances that make the area unappealing to your cat. Different cats have different reactions to these formulas. You may have to try several until you find the one that works best, and always test these products in an inconspicuous area before spraying the entire surface.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some owners have luck with vinyl claw covers that adhere to the cat’s claws. They last until your cat sheds that layer of claw and must be reapplied when they fall off. Altering your cat may lessen the clawing instincts of course. (For information on the controversial procedure of declawing, see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day271",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 316")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0064-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day56"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 65")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Say “Cat” in Many Languages")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS HAVE BEEN OUR COMPANIONS")]), _vm._v(" since ancient history. The root of each word for "), _c('em', [_vm._v("cat")]), _vm._v(" often describes how cats look or act, or what they do. For instance, terms used for cats in the Middle Ages translate to “mouser.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here are some modern words for our feline friends in several languages:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Albanian:")]), _vm._v(" mace")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Arabic:")]), _vm._v(" biss/hirrah/qitah/quttah/qatt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Armenian:")]), _vm._v(" gatz")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Basque:")]), _vm._v(" catua")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Berber:")]), _vm._v(" kadiska")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Bulgarian:")]), _vm._v(" kotka")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Catalan:")]), _vm._v(" gat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Cherokee (Tsalagi):")]), _vm._v(" wesa")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Chinese:")]), _vm._v(" mao")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Cree:")]), _vm._v(" bushi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Czech:")]), _vm._v(" kocka")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Danish:")]), _vm._v(" kat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Dutch:")]), _vm._v(" poes")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Egyptian:")]), _vm._v(" kut")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("English:")]), _vm._v(" cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Esperanto:")]), _vm._v(" kato")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Estonian:")]), _vm._v(" kiisu")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Farsi:")]), _vm._v(" gorbe")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Filipino:")]), _vm._v(" pusa")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Finnish:")]), _vm._v(" kissa")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("French:")]), _vm._v(" chat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Fula (New Guinea):")]), _vm._v(" gnari")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Gaelic:")]), _vm._v(" cait")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("German:")]), _vm._v(" Katze")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Greek:")]), _vm._v(" ga’ta")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Gujarati:")]), _vm._v(" biladi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Hawaiian:")]), _vm._v(" popoki")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Hebrew:")]), _vm._v(" chatul (with a guttural, "), _c('em', [_vm._v("k")]), _vm._v("-like "), _c('em', [_vm._v("ch")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Hindi:")]), _vm._v(" billy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Hungarian:")]), _vm._v(" cica/macska")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Icelandic:")]), _vm._v(" köttur")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Italian:")]), _vm._v(" gatto/a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Japanese:")]), _vm._v(" neko")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Korean:")]), _vm._v(" ko-yang-i")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Lithuanian:")]), _vm._v(" katinas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Malay/Indonesian:")]), _vm._v(" kucing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Maltese:")]), _vm._v(" qattus")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Mayan:")]), _vm._v(" miss")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Norwegian:")]), _vm._v(" katt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Polish:")]), _vm._v(" kot")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Romanian:")]), _vm._v(" pisica")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Russian:")]), _vm._v(" kot/koshka/olena")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Saudi Arabian:")]), _vm._v(" biss")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Slovak:")]), _vm._v(" macka")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Spanish/Portuguese:")]), _vm._v(" gato/a")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Swahili:")]), _vm._v(" paka")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Swedish:")]), _vm._v(" katt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Syrian:")]), _vm._v(" qati")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Thai:")]), _vm._v(" meo")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Turkish:")]), _vm._v(" kedi")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Ugandan:")]), _vm._v(" paka")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Ukrainian:")]), _vm._v(" kotuk")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Vietnamese:")]), _vm._v(" meo")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Welsh:")]), _vm._v(" cath")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_c('strong', [_vm._v("Zulu:")]), _vm._v(" ikati")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "id": "day57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 66")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Changing Cat Food")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F YOU DECIDE TO TRANSITION")]), _vm._v(" your cat to different food, do so gradually. Say you decide to dump a dry-food regimen for wet food, which contains the protein that cats desire without carbohydrates that can become problematic for overweight cats. Maybe you want to switch food brands because the one you’re currently feeding your cat is no longer available. Plan several days, and ideally one week, to introduce this dietary change to your cat. Otherwise, she will have no interest in dining (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 171")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every cat will respond differently to dietary changes. Some can stomach a quick change, but most need time to adjust.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spend time mixing old and new food, and the mealtime switch will be minimally disruptive. (Your cat’s litter box will let you know otherwise.)")]), _vm._v(" "), _c('p', {
    staticClass: "blackquote"
  }, [_c('strong', [_vm._v("Day 1:")]), _vm._v(" 90 percent original food, 10 percent new food")]), _vm._v(" "), _c('p', {
    staticClass: "blackquote"
  }, [_c('strong', [_vm._v("Day 2:")]), _vm._v(" 80 percent original food, 20 percent new food")]), _vm._v(" "), _c('p', {
    staticClass: "blackquote"
  }, [_c('strong', [_vm._v("Day 3:")]), _vm._v(" 70 percent original food, 30 percent new food")]), _vm._v(" "), _c('p', {
    staticClass: "blackquote"
  }, [_c('strong', [_vm._v("Days 4–10:")]), _vm._v(" continue pattern of decreasing original food and adding more of the new variety")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0066-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day58"
    }
  }), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 67")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Make a Foraging Box")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS EASY-TO-MAKE BOX")]), _vm._v(" will keep your cat occupied and develop his foraging abilities. The kibble you add to the box should be a share of his normal portion, not an additional amount.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("MATERIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 flat stones, 2 to 3 inches (5.1 to 7.6 cm) across (to weight the box down)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pencil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cardboard shoe box with lid")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("X-acto knife or razor knife")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 to 6 small plastic balls, such as Ping-Pong balls")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 to 6 smooth, plain plastic napkin rings")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8 to 10 pieces dry cat kibble")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Masking tape")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Rinse the stones to remove any dirt and dry them thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" With a pencil, mark six small circles or squares around the box, two on each of the long sides and one on each short side. The circles or squares should be smaller than the balls you are using, but big enough for your cat to get her paw through, and about 1/2 inch to 1 inch (1.3 to 2.5 cm) from the bottom of the box.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Using the knife, carefully cut out the openings you marked.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Set the box right side up. Put a stone in each corner of the box, then add the balls and napkin rings. Distribute the kibble in the box. Replace the lid and tape down with the masking tape.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Place the box on the floor and let your cat enjoy figuring out how to get to the kibble.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0067-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "id": "day59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 68")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Bengal")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENGAL COMES FROM A")]), _vm._v(" family of exotic relatives; it’s the descendant of an Egyptian Mau and an Asian Leopard.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" Bengals’ coats have expanded to several colors—silver and various tones of brown, from buff to sepia—with a high-contrast marbled or spotted coat. The marbled variety is deeply swirled along the horizontal, unlike striped tabbies. One particularly interesting color is known as “hot rufus” for its intense orange hue; another variation, the seal lynx point, is spotted all over but with darker point markings. The preferred style of spotting for show cats features rosettes rather than the ordinary polka-dot sort of spots. Whatever their color or pattern, Bengals have complex stripes on their faces, and their spots continue all the way down their tail and along their belly.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0068-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Bengal")]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_vm._v("Perhaps the most striking characteristic of the Bengal is its size; males can reach 20 pounds (9 k) or more without being chubby. They have a strong and muscular build. Although Bengals can be real pussycats if raised with affection, they do tend to exhibit innate feral behavior when playing, such as attacking their toys as if genuine prey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This rare breed’s availability is hampered by the fact that, because its genetic mix crosses species barriers, the males are often born sterile. On the upside, further experiments with crossbreeding have resulted in even some longhaired Bengals.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" Most of today’s Bengals have descended from experiments by California breeder Jean Mills, who mated several early Bengals with several different domestic cats to see what would happen. The result was tawny, spotted litters of remarkable size and strength. They began to enter cat shows in 1991.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > Bengals take well to being leash trained.")])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('a', {
    attrs: {
      "id": "day60"
    }
  }), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 69 + 70")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("What Your Cat’s Tail Is Telling You")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE TYPICAL CAT’S TAIL HAS")]), _vm._v(" twenty to twenty-four bones. Although the flexible tail helps a cat balance, it is also an important communication tool. We all know that a cat who walks with a drooped tail between his legs is feeling very sorry for himself. An upright tail signals a secure cat that feels so full of himself that he’s raised his proud “flag.” Here are some other interesting “tell-tail” signs:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("A quiver in an upright tail:")]), _vm._v(" This can indicate anticipation, generally of a positive kind; many cats use this gesture when they expect to be fed imminently.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("A full, erect tail:")]), _vm._v(" Often coupled with hair standing on end all over the cat’s body, this tail position signals aggression. He is making himself as large and threatening as possible. An angry cat will also wave the enlarged tail to make it seem even more enormous to an enemy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("A horizontally, sharply twitching or whipping tail:")]), _vm._v(" Kitty is annoyed—by another cat, or even by you—or he feels frustrated. If you admonish your cat, for example, he may not talk back vocally, but a twitching tail will give away his displeasure. A submissive cat, threatened by an aggressor, will thump his tail.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("A wagging tail:")]), _vm._v(" This is a softer gesture, and is done such as while listening to music or to indulgently provide an object of play for a kitten; the entire tail may move, or just the tip.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("An extended tail, or a tail wrapped closely around the body:")]), _vm._v(" This is performed while sitting or sleeping, or when the cat feels threatened by another animal, or even the vacuum cleaner.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("A tail held to the side:")]), _vm._v(" Called the lordosis position, a female cat in heat, crouching low, may position her tail this way.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Tail sniffing:")]), _vm._v(" Cats sniff and even taste the base of each other’s tails, where scent glands are located, to confirm each others’ identity. This can be an aggressive gesture, an invitation to play, or a simple “hello” greeting. Kitty may even present his rear end to you, expecting you to appreciate his presence. Greeting him pleasantly by name will usually satisfy his urge to check that you know who he is!")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > You may be able to defuse your cat’s aggression simply with a sharp command, “Put that tail down!” if you have taught him the words "), _c('em', [_vm._v("tail")]), _vm._v(" and "), _c('em', [_vm._v("down")]), _vm._v(". He may automatically obey—and once his tail goes down, slimming toward looking normal, it’s difficult for him to remain angry! Chances are, he’ll do an embarrassed lick and walk away nonchalantly, as if he had never issued a threat.")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }), _c('a', {
    attrs: {
      "id": "day61"
    }
  }), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 71")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Choosing a Shelter Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIMAL SHELTERS ARE USUALLY")]), _vm._v(" full of cats of all different types and personalities, all looking for a safe and loving home. As an animal lover, you will want to fill your home with these sweet pets—how can you choose just one? There are limits. Ask yourself these questions to narrow down your decision and choose the kitten or cat that is right for you.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Before you go to the shelter, think about what kind of cat you want to adopt. Male or female? Independent or a clingy personality? Short hair or long hair?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• How much time do you have to devote to training? A cat with behavioral problems will require plenty of attention to overcome them.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• How much time can you devote to grooming? A longhaired cat requires frequent brushing and sometimes bathing.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Can you handle a cat with medical problems, one that might require daily pilling or frequent vet visits?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Are you looking for a kitten, or would you consider an older cat? Kittens are adorable, but older cats can be just as loving once they get to know you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When you get to the shelter, ask to see cats that fit your criteria. The staff at most animal shelters are usually familiar with the cats in their care; find out about the personalities of the different cats. Keep in mind, though, that shelters can be stressful places for cats, and they might not be displaying their best manners or be as friendly as they normally are out of that environment.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once you narrow down your selection to a few cats, spend some quality time with each cat, away from the other cats, if possible. Give them time to warm up to you and show you a little of their personalities. Usually, there’s one cat that tugs a little harder at your heartstrings than the others.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before you fall completely in love, though, ask the shelter staff about that cat in particular. What do they know about the situation she came from? How does she behave around other cats? Is she generally friendly to people? Are there any behavioral or medical problems they know of? Ask them about their return policy, too, in case the match doesn’t work out—it does occasionally happen. If the answers satisfy you, congratulations! You’ve found your special kitty.")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "day62"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 72")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cats Under the Big Top")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THEATER, A CAT THAT CROSSES")]), _vm._v(" the stage will bring bad luck to the performance, but a well-known troupe of Russian felines has bucked this superstition. In 1971, Yuri Kuklachev, then studying to be a clown, came upon a cat that earned its food by performing acrobatics for passersby. The clown study envisioned a partnership.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He adopted the cat, figuring they could work together. He named her Strelka, and the duo performed together with the Moscow State Circus.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Kuklachev left the circus to create his own, he promoted cats to the main act, and the circus became known as the Moscow Cat Theatre. The troupe is still going strong, led by Kuklachev’s son, Dmitri. The four-footed company roster comprises about 150 cats, some shelter cats and others given to the company. An occasional dog (meow!) also takes the stage.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The troupe’s tricks include tightrope walking, riding skateboards and bicycles, standing on their forepaws, rolling hoops and balls, jumping incredible distances, and other awe-inspiring feats. Some cats even accept being dressed in Russian folk costumes, which they wear while walking erect on their hind legs. Themed performances include "), _c('em', [_vm._v("Prince Nutcracker and the Mouse King")]), _vm._v(" and even a feline take on "), _c('em', [_vm._v("Swan Lake")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Trainers work with the cats for eight months to two years. Cats that display particular gifts for, say, jumping or rolling, are encouraged to do them on command.")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('a', {
    attrs: {
      "id": "day63"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 73")])]), _c('a', {
    attrs: {
      "id": "day63"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Protect Against Rabies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABIES IS A SERIOUS DISEASE")]), _vm._v(" that affects animals and can be transmitted to humans. It is critical to keep your cat safe from rabies for your own protection and for the safety of other people and animals that come in contact with your cat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The most common carriers of rabies are raccoons, bats, and to a lesser extent skunks. These animals are nocturnal and usually come out at dusk. If a raccoon or skunk is in daylight, it can be a sign of sickness. Stay away, bring your cat inside, and call your local animal control officer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To keep your cat safe:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Keep rabies vaccinations up-to-date for all cats (and dogs and ferrets), especially if they could possibly encounter wildlife.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Spay or neuter your cat to reduce his impulse to wander.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Do not allow your cat to roam without supervision.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Call your local animal control officer to remove stray animals from your neighborhood.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Train and socialize your cat to reduce the risk of his biting a person or another cat.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• If you plan to travel internationally with your pet, contact the Department of State in your destination country to find out about health documentation requirements and quarantine laws.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rabies is responsible for 55,000 deaths per year in the world, per the Global Alliance for Rabies Control. Preventive measures such as vaccination have greatly reduced the risk to pets and humans of contracting rabies, but it is still a serious concern.")])]), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('a', {
    attrs: {
      "id": "day63"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "day63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0072-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('a', {
    attrs: {
      "id": "day64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 74")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Growing Catnip Indoors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS LOVE CATNIP")]), _vm._v(", and growing your own is easy. Here is a brief tutorial to get you started.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Catnip ("), _c('em', [_vm._v("Nepeta cataria")]), _vm._v(") is a member of the mint family and related to basil and oregano. It grows to about 2 to 3 feet (61 to 91 cm) high and has clusters of white or purple flowers. Catnip has a pleasant lemon-mint scent. The leaves, stems, and seedpods contain an essential oil that most cats can’t resist. If you plant catnip in your garden, expect to see a stray rolling around in the garden once in a while.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The plants are available at many nurseries and garden centers, or they can be grown from seed after the threat of frost has passed. Catnip thrives in well-drained soil in a sunny location, but will also do well in partial shade. If your soil has a lot of clay, add a few trowelsful of sand to the soil as you’re preparing it for planting to improve drainage.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Catnip is a perennial, so it will come back year after year once it is established. Like other mints, it can easily spread out of control and crowd out other plants because it reproduces by seed and by sending up new shoots from existing roots. You can help prevent rampant spreading by planting it in a container, then planting the container in the ground (this will confine the roots to the diameter of the pot), and by keeping the plant trimmed back and not allowing it to flower, thus preventing seeds from forming.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Trimming will also prevent the plant from getting “leggy” and encourage full, dense growth. When the plant has grown to 3 to 4 inches (7.6 to 10.2 cm) high, trim the stems just above the last set of leaves. This will cause the plant to start two new stems just above those leaves. Repeat this procedure through the growing season, allowing the plant to grow 3 to 4 inches (7.6 to 10.2 cm) between trimmings.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Harvest catnip when the flowers are just starting to bloom. Cut the stems a few inches (7.6 cm) below the flowers. Your cat can enjoy some of the bounty fresh, and you can dry the rest for later use. To dry, spread out the leaves and flowers on trays or hang them in a cool, well-ventilated area. Once they are completely dry, seal them in airtight bags or containers out of Kitty’s reach. Dried catnip will maintain its potency for about a year, longer if you keep it in the freezer.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Humans use catnip, too, for herbal teas and in cooking. Practitioners of herbal medicine say it is good for treating cold symptoms and general aches and pains.")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _c('a', {
    attrs: {
      "id": "day65"
    }
  }), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 75")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Birman")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRMAN IS THE SACRED CAT")]), _vm._v(" of Burma, now called Myanmar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" The Birman has a silky, long coat that has a unique twist with regard to color. Although its ears, mask, legs, and tail are color-pointed, and its body may be creamy or silvery in tone, its feet are pure white. Birmans don’t have exotic characteristics, such as a long nose or an angular body. They are broad-faced, with a Roman nose, and have a powerfully built, cobby body under all that fur. Except for their white feet, they share point colors with the Siamese.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("A shorthaired cousin of the Birman that has developed in the United States is called the Snowshoe (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day257",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 299")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" Burmese legend has it that in olden times, a temple renowned for its resident white longhaired cats was attacked by bandits, and one of the cats, named Sinh, jumped onto the head of the most venerated of the priests, Mun-Ha, to protect him. Although Mun-Ha died, the holy act produced colorpointing on the cat—except on its feet, which clung to Mun-Ha, and Sinh’s amber eyes turned vivid blue. The cat stayed by the priest’s corpse for an entire week. Then, Sinh died, and all the other cats of the temple instantly turned the same colors. They collectively selected Mun-Ha’s successor among the priests by solemnly walking in a circle around him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fast-forward to 1919, when a British major named Russell Gordon and French explorer Auguste Pavie, who helped priests and their cats flee that very same temple to Tibet when it was again under attack, were given a pair of Birmans in thanks. The female cat was already pregnant, and that litter, reproducing in France, developed the breed in the West. Skeptics say, however, that the cats originated in France from crossbreeding a Siamese with black and white longhaired cats. Whatever the truth of the matter may be, cat associations in Great Britain recognized Birmans in 1966; in the United States, in 1967.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > The Birman is an entirely different breed from the shorthaired Burmese, which also comes from Myanmar.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0074-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Birman")])]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day66"
    }
  }), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 76 + 77")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cat Tricks: Roll Over, Stretch, Wiggle, and Squish")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS OFTEN ROLL OVER AND STRETCH")]), _vm._v(" all by themselves. To turn this into delightful tricks, catch your cat in the moment and use verbal cues to identify the action.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Roll Over")]), _vm._v("—Your cat may roll around on her back in sheer pleasure, or to wash a hard-to-reach spot. When she does a full roll, immediately call out enthusiastically, “[Name] roll over!” while making a small circle in the air with your hand. Do this whenever you can, as appropriate to each incident being a full roll.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Phase two: When she is already comfortably lying on the floor, begin to introduce the phrase as a command, complete with the gesture. Praise your cat any time she does the rollover for you: “Good [name] roll over!”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Phase three: When she has mastered phase two, ask her to roll over if she is not lying down, but sitting, standing, or walking, and praise her if she complies. Remember to praise her any time she rolls over spontaneously.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Continue to use the terms in context to reinforce the behavior, and work your cat to the point of doing it with either just the verbal command or the hand gesture.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Stretch")]), _vm._v("—This is very much the same as rolling over, but entails catching your cat in a full-body stretch and identifying it verbally: “[Name] stretch,” while stretching your own body, arms in the air, or using just a hand signal of opening a fist into wide-apart fingers. Repeat the phases as above, with these substitutions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Wiggle")]), _vm._v("—This is a cousin of the rollover command, only here you are watching to see your cat squirm happily on the floor. Identify it verbally, in the moment: “[Name] wiggle,” while flopping a hand in the air, then reinforce as above.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Squish")]), _vm._v("—You can command your cat to knead a soft surface. Use the above method, while she is already doing it, stating, “[Name] squish,” while opening and closing your fingers from a fist shape. Once your cat masters this, she may even be willing to open and close her own fists in the air when she is lying down, in response to your verbal or hand command.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In all cases, be sure to praise your cat with a repetition of the correct command term when she obeys your order, to reinforce her having done the action correctly.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "day67"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 78")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Choosing a Purebred Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F YOU HAVE YOUR HEART SET ON")]), _vm._v(" a purebred cat, chances are you will need to go through a breeder. Common breeds such as Persians and Siamese do occasionally end up in shelters, but not often. To begin your search, first you need to decide which breed of cat you want. Friday breed descriptions in this book provide information that can help guide the decision.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once you narrow down the vast cat kingdom and isolate a few breeds that interest you, talk to breeders and other owners who have experience with these cats. Many breeds have a tendency toward certain medical problems; what are they in the breeds you are considering? What are the personalities of those breeds like? What kind of grooming or other special care is required? How do these answers mesh with your lifestyle and budget?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After you decide on a breed, find a reputable breeder. Good breeders should be very knowledgeable about the breed and happy to answer any questions you might have. They should allow you to inspect their facilities and should be just as interested in evaluating you as a prospective owner as you are in evaluating them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Above all, remember that an impressive legacy and prize-winning parents do not necessarily mean a good, healthy cat. Check out your new kitten to be sure she is healthy, friendly, and well adjusted before taking her home.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('a', {
    attrs: {
      "id": "day68"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 79")])]), _c('a', {
    attrs: {
      "id": "day68"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("This Little Piggy . . .")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OST CATS HAVE FOUR TOES")]), _vm._v(" on each back paw, arranged in a line, and five toes on each forepaw, with four arranged in a line and the fifth offset, somewhat like a human thumb. This offset toe is called a "), _c('em', [_vm._v("dewclaw")]), _vm._v(". Although the dewclaw is positioned like a thumb is on a human hand, it is normally not opposable and can’t be used to grasp an object.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A common genetic mutation in cats sometimes results in cats with six, seven, or more toes. This condition is called polydactyly, and it is considered in most cases to be merely an anomaly, not a deformity. When it occurs, it almost always affects the forepaws and sometimes also the back paws, but rarely only the back paws.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Polydactyly is observed in cat populations all over the world, but is more common in some areas than in others, including the east coat of North America and southwestern Britain. Because it is a dominant genetic trait, it is easily passed on to a polydactyl cat’s offspring. The offspring of Ernest Hemingway’s cat colony in Key West, Florida, are famous for having an abundance of polydactyly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Polydactyly generally doesn’t cause any health problems, unless the toes or claws are malformed. Your vet will be able to tell you whether there is any cause for concern and will recommend treatment if it is warranted.")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day68"
    }
  }), _c('a', {
    attrs: {
      "id": "day69"
    }
  }), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 80")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Shoo Away Fleas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FLEA IS A SMALL, JUMPING")]), _vm._v(", parasitic insect that lives by consuming an animal or a human host’s blood. Fleas used to be considered merely a nuisance, but today we know they can carry diseases harmful to both humans and animals. These include plague, bubonic plague, pneumonic plague, and flea-borne typhus. When the flea bites its host, it can transmit whatever disease it may be carrying.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cats aren’t the only carrier of fleas, either. Other house pets, including dogs, as well as outdoor creatures such as squirrels, rabbits, mice, horse, chickens, raccoons, possums, and foxes—and even humans—are all possible hosts for fleas.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fleas are similar to cockroaches in that they outlive and outlast most other insects. They are difficult to kill because of their four-stage life cycle and because they don’t spend most of their time on their host, which makes the problem of locating them and wiping them out even harder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fleas have four stages of life, and at every stage they can lay dormant for several months. Female fleas lay about twenty eggs per day and up to six hundred in a lifetime. Eggs can be laid in animals’ fur, carpeting, bedding, and even the family couch. Even your car and vacuum bag are attractive breeding grounds for them. Flea eggs typically hatch within two days to two weeks. In the first stage, the larva, the flea is blind.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Its food source is digested blood from adult fleas’ feces, dead skin, hair, feathers, and organic debris. Fleas mature within a cocoon-type sac built with pet hair and carpet fibers. In anywhere from five days to two weeks, an adult flea emerges. Now the hunt for a host begins, so it can find its first meal and begin growing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When trying to eliminate fleas, it’s not just about the animal; it’s also about your living environment, your mode of transportation, and your outdoor facilities. In addition to treating your cat, you will have to pay close attention to these areas, to keep the flea situation under control. For your car and couch at home, try sprinkling some borax powder into your carpet and on your furniture. It is most important to keep your cat’s sleeping area clean and free from fleas at all times.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Be careful using do-it-yourself flea treatments. Read and understand the directions before starting. Many of these products can be harmful to you and your cat if not used correctly. If you have a severe flea infestation, hire a professional exterminator, who will be able to recommend the safest and most effective course of treatment for your particular situation, inside and out.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('a', {
    attrs: {
      "id": "day70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 81")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Compile Vital Stats in a Cat Binder")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLECTING ALL OF YOUR CAT’S")]), _vm._v(" important health and contact information into a sturdy three-ring binder makes it easy to keep track of all her paperwork and notes. You can tote this binder with you to the vet, or leave it as a manual for the cat sitter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Binders with clear plastic pockets on the outside allow you to personalize it with your cat’s name and photo, or you can choose a beautiful leather version or a fun and colorful design. Use plastic page protectors to preserve important original papers and tab dividers to organize the sections. Loose-leaf paper is handy for keeping notes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is what you should keep in your binder:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• A current photo of your cat (handy if she gets lost)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Your cat’s name")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Your name, address, telephone number, and other contact information")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Your vet’s name, address, telephone number, and other contact information")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Your animal hospital’s name, address, telephone number, and other contact information")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Written directions to the animal hospital (you don’t want to get lost if there is an emergency)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• The name, address, telephone number, and other contact information for an emergency contact, should you be unavailable")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• City or county registration numbers, paper licenses, and other government paperwork")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Breed information and registry papers, if your cat is a purebred")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Type and amount of cat food she eats")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Feeding schedule")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Vaccination records")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Type and amount of any medications she takes regularly")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Records of illnesses and vet visits")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Microchip type and registration number and contact information for the registrar (in case you need to change your contact information)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Names and contact information for cat sitters")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Notes on any special things a stranger caring for your cat should know; for example, “doesn’t like catnip,” “doesn’t like her belly to be touched,” “prone to escape through the side door,” or “likes to hide under the sofa”")])]), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0079-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('a', {
    attrs: {
      "id": "day71"
    }
  }), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 82")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Bombay")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE JET-BLACK, SATINY APPEARANCE")]), _vm._v(" of the Bombay sets it apart from all other domestic cats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" Bombays have a round face, with amber to copper eyes, the latter being the most prized color. Their fur is very short and they shed very little. Whatever skin leather can be seen, on nose and paws, is pure black.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" The Bombay was developed in the United States in 1958, when a brown Burmese was mated to a black American Shorthair. The all-black kittens had Burmese-type super-short fur, and a new breed was born. The name was chosen because of the cats’ resemblance to the panthers of India; had they been born a few decades later, they might have been known as Mumbais!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For a while, confusion reigned in the show world over how pure this breed was, because Bombays continued to be mated with American Shorthairs rather than among their own separate breed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Genetics sometimes skew the classification of offspring in another way: Some Bombay kittens are born deep brown rather than black. To this day, some cat registries balk at allowing the brown ones to be shown as Bombays. The breed was accepted into American cat associations in the 1970s, but Great Britain has dragged its feet in this regard.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > The Bombay’s coat color is so striking that in some U.S. cat shows, fully half the award points concern the pure blackness of the fur.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0080-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Bombay")])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _c('a', {
    attrs: {
      "id": "day72"
    }
  }), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 83 + 84")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Story: On Being a Foster Mom")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("Y HOUSE FELT COMPLETELY EMPTY")]), _vm._v(". After having two cats for more than a decade, hearing the pitter-patter of eight paws and the banter between the longtime sibs, a house without cats was simply not home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I began volunteering at Public Animal Welfare Society (PAWS) shortly after I solved my empty-house problem and adopted two cats. They were bottle-fed, extremely sociable, and thank goodness, accepting of other “visitor” cats. I’ve hosted plenty of them since their homecoming.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I was a foster mother to fifteen cats during a high point, though usually I care for an average of four (not including my two cats and dog, also adopted from foster homes). I never would have imagined setting up cat condos in my home to cater to homeless cats. But that’s exactly what I do. I have fostered kittens, feral cats, a pregnant mother, and other homeless felines I simply can’t turn down when the agency asks me to give them shelter. They must have pegged me for a sucker. They were right!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("PAWS is a grassroots organization that finds foster homes for homeless cats, then carefully screens adoptive parents, matching families with appropriate pets. Our return rate is low, and the community’s need for our service is tremendous. We cannot save every cat, and we certainly will not find a warm home for every stray on the street. But we can make a big difference for the cats we do foster, and for the families who welcome a new pet into their homes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fostering is not for the faint of heart. I wasn’t sure how I would handle taking in cats, caring for them, and then giving them away to another family. I had never experienced that sort of temporary love, though I realized pretty fast that my heart would just keep getting bigger and bigger—more room for more cats. I decided right off the bat to dedicate a room in my house to fostering. For the most part, I keep my house cats separate from foster cats. By not integrating foster cats into my pet family, I have been able to tend to them like a nurse, giving them medicine and food and love.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Only a couple of times did I wane from my self-imposed duties. I kept the mother cat I found in my backyard. Her social behavior improved dramatically, and I integrated her into my home. I worried about her fate as a potentially undesirable adoptee for families, so she’s mine now. There have been extended-stay incidences, times when foster cats live here so long I wonder what will happen. But eventually, they get what they’ve deserved all along: a loving, permanent home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a way, I feel like I’m still mother to the cats who live here, even if only for a week . . . I care for them, raise them up, then proudly say goodbye when it is time for them to move on. Fostering cats is tremendously fulfilling. And between my volunteer work at PAWS and my own pet family—now three cats and a loyal dog—I never experience a quiet house. And that’s a good thing.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('a', {
    attrs: {
      "id": "day73"
    }
  }), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 85")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cat-Proof Your Home")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E’VE ALL HEARD THAT SAYING")]), _vm._v(", “Curiosity killed the cat.” Even the best-maintained household contains dangerous items that could hurt or poison your cat. Here is how to keep Kitty safe:")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("GENERAL TIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Protect electric cords and unplug small electronics when not in use. Cords and plugs can be blocked by objects or encased in dedicated materials available in hardware stores. Use childproof covers for unused outlets, if necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Discourage Kitty from sitting atop electronic devices such as stereo or video equipment, heaters, and so on, which could overheat if vents are blocked.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Use candles only with human supervision.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Store plastic bags and bags with handles out of Kitty’s reach, as well as rubber bands, twist ties, thumbtacks, paper clips, staples, erasers, and all other items small enough to be ingested.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Put away scissors, knives, razors, craft blades, and other sharp objects that your cat might chew on or bat around.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Store all drugstore items, potpourri and essential oils, cleaning materials, toiletries, and cosmetics out of reach of your cat, preferably in a latched cabinet.")])]), _c('p', {
    staticClass: "bulletlist"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("• Keep cat-friendly plants only (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 269")]), _vm._v("). Be careful about using cut, dried, or artificial plants, which Kitty may chew.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Take extra care when selecting holiday decor (see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 242")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Put away batteries and small electronics that contain them (such as hearing aids). Batteries contain chemicals that are very dangerous to a cat’s insides!")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Secure windows so that your cat cannot squeeze through even a small opening. Use screening, screwed into place if necessary, to keep Kitty inside. See "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 130")]), _vm._v(" for more about preventing “high-rise syndrome.”")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Block off unsafe areas, such as rooms where painting, repairs, or construction is occurring.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Create at least one cat-free zone if you can, either if the room is too hard to cat-proof or you would like a place where you can work undisturbed on crafts or other activities.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("KITCHEN")])]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Store foods and beverages in closed containers, cabinets, or the fridge, especially those that could make your cat ill (see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 178")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Keep your trash in a bin your pet cannot open, and empty it often. Carefully dispose of used food wrappers and Styrofoam containers; your cat may try to chew on them.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Clean up spills. Do not leave soapy water or cat-unfriendly food/drink in dishes or pans sitting in the sink.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Feed your cat from dishes, not opened cans, whose sharp rims could cut Kitty’s tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• If your cat raids cupboards or has learned to open the fridge, install childproof latches or hooks to keep the doors closed.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Turn pot handles toward the inside of your stove top, and use protective covers for your stove’s control dials if your cat can easily reach them. Teach your cat not to sit immediately next to the burners.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Consider shutting your cat out of the kitchen (if possible) if you are doing any high-heat procedures, such as deep-frying.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('strong', [_vm._v("BATHROOM")])])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Put away ribbons, hair elastics, and other such items that your cat may attempt to ingest.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Don’t share hot or herbal/toiletry-scented baths with your cat.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Keep your toilet’s lid shut!")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• If you use the bathroom to launder your clothing, shut your cat outside the room if anything has been left to soak.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("OTHER LIVING SPACES")])]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Avoid using electric blankets and pads with inner wires that can shock a cat’s claws.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Be particularly careful with craft items, such as needles and pins, sewing thread, yarn, beads, glue, paints, and chalks. If your cat is nearby while you work on a craft project, know where such materials are at all times and put them away immediately or bring them with you, if you are called away.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Do not let Kitty play with yarn, thread, or cut fabric that can ravel easily—a swallowed length of thread is sharp and can kill a cat! (If your cat has swallowed thread or yarn, bring him to the vet immediately without attempting to pull it out by its end!)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Avoid decor that includes cords, fringes, beading, or other edible decorative elements. Remove them or tie them well out of reach of Kitty.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• If your cat likes to chew on wool, vinyl, rubber, or other materials, be mindful of what substances rugs, furniture, and soft furnishings are made of, and take measures to protect or replace them.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Absolutely do not use naphtha or other chemical insect repellents, or traps/poisons to kill vermin. Use natural, cat-safe herbal mixtures only.")]), _vm._v(" "), _c('p', {
    staticClass: "h4"
  }, [_c('strong', [_vm._v("THE GARAGE, BASEMENT, AND OUTDOORS")])]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Carefully store such materials as antifreeze, petroleum products, paint, cleansers, and so on, as well as sharp tools, nails, and screws. Clean up spills of such substances or objects.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Use all-natural insect/vermin preventives and lawn-care products.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Always check that your cat is not inside a washer or dryer before turning it on. Shut washer and dryer doors when not in use.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Protect any dangerous areas your cat could climb into/under/behind, such as openings in walls or ceilings, behind large electronics, and so on. Be especially careful with any heated units your cat might want to snuggle against or into, such as a furnace.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Check that Kitty is not trapped in the garage before you shut its door.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Check that fencing or open drains do not have openings of a size a cat could wedge into and get stuck.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }), _c('a', {
    attrs: {
      "id": "day74"
    }
  }), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 86")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Guardian Angel")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME PEOPLE BELIEVE CATS HAVE")]), _vm._v(" special psychic powers or extra senses. In 2007, a gray and white cat named Oscar rocketed to fame worldwide for a special ability that is a mixed blessing: He knows when someone is about to die.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("From kittenhood, he has lived in Rhode Island’s Steere House Nursing and Rehabilitation Center for people with Alzheimer’s and other forms of dementia. The staff began to notice something very odd about Oscar’s relationship with hospice patients. Just like the human staff, he would circulate among the rooms, checking up closely on everyone—but when he would curl up to a particular patient, that person would die within the day.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oscar has correctly predicted patients’ last hours at least twenty-five times, outstripping the nurses and doctors’ abilities in that capacity. And he is not a lap cat, either; ordinarily, he is not a cuddler. Yet, if he is shut out of the room of a dying patient, he is distressed, wishing to be let in to lie beside the person.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("His behavior is so accurate that the nurses know to call an individual’s family if he appoints himself to that man or woman’s bed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("So, what draws Oscar to the terminally ill? Staffers guess that something changes about a dying person’s body chemistry—and therefore, his or her scent—which only Oscar is able to detect. Whatever the case, the patients Oscar consoles in their final hours are grateful for the companionship. Only one family demanded his removal from their loved one’s room.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In geriatrician David Dosa’s article about the cat’s special gifts in the "), _c('em', [_vm._v("New England Journal of Medicine")]), _vm._v(", the daughter of a woman being tended by Oscar explained it thusly to her young grandson: “He is here to help Grandma get to heaven.” To have a concerned cat snuggling close, keeping vigil by your side, must surely be a comforting, rather than grim, way to go.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0084-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('a', {
    attrs: {
      "id": "day75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 87")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("The Importance of Playtime")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAY IS ESSENTIAL TO YOUR CAT’S HEALTH")]), _vm._v("—and your sanity. A bored cat will find ways to “keep busy,” and those activities generally result in a frustrated owner. If you’ve ever returned home to find that your cat used the dining room table to sharpen his claws, or decided the heirloom grandfather clock was more interesting than his scratching post, then you understand that cats need quality exercise to stay out of trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Besides the “good kitty” factor, exercise will improve your cat’s circulation, stimulate vital organs, aid digestion, and eliminate harmful toxins from the body. Your cat will feel mentally stimulated and physically satisfied after a quality play session.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Aim to exercise your cat for ten minutes, four times each day. House cats especially require dedicated playtime because they don’t burn calories and stimulate their feline instincts by roaming outdoors. It’s your job to stoke their curiosity and challenge them with games. A great time to exercise your cat is before mealtime. This way, you cater to your cat’s natural cycle: hunt, kill, eat, groom, sleep (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day78"
    }
  }, [_vm._v("Days 90")]), _vm._v(" and "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day78"
    }
  }, [_vm._v("91")]), _vm._v("). Playtime is your cat’s modern-day hunt-and-kill activity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Not sure where to start? Begin by stocking your kitty’s toy chest with safe, stimulating options (see "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day9"
    }
  }, [_vm._v("Day 10")]), _vm._v("). Cats love things that dangle, bounce, and move—these actions require chasing and pouncing, which are cats’ natural instincts. Use a laser light to rouse a napping cat, or purchase a remote-controlled mouse. Even Ping-Pong balls and wads of crumpled paper are a thrill. The key is that you’re involved in the play.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Provide a couple different scratching posts and perches throughout your house so Kitty can play when you’re not home.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cats get a kick out of pawing and pouncing after items dangled from fishing line. Rig your own toys by tying an object or a cat toy to a length of string. Play hard-to-get, and tug on the string and drag the object around the house. You lead—your cat will follow.")])]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day76"
    }
  }), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 88")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Facial Pheromones Can Prevent Scratching")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEROMONES ARE CHEMICALS")]), _vm._v(" produced by scent glands on your cat’s face, near his anus, and on his paw pads. Cats use these chemicals as a way of marking their territory and communicating with each other. Facial pheromones, produced along your cat’s chin and on his forehead, have a calming effect on cats. Cats rub their chins on the corners of walls, chair legs, and other protruding objects to mark them as friendly territory and communicate comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Synthetic facial pheromones mimic the effects of natural facial pheromones and are available in spray form or in plug-in diffusers. By marking territory (furniture and other hot spots for scratching) with man-made pheromones, your cat catches the scent and associates these areas as already marked. Your cat will determine the territory is “comfortable” by his standards, and will not feel the need to scratch or rub against the object.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Research has shown that cats tend not to urine mark or scratch objects that have been marked with facial pheromones, so spraying them on furniture and other objects may help reduce or eliminate these problems.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sprays are also useful when traveling. Use the spray on the inside of the carrier to help keep your cat calm. Treat an entire room with a pheromone diffuser. These can be a lifesaver when moving to a new home or introducing another pet to the home. Be sure to follow the manufacturer’s instructions carefully.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cats don’t really “smell” pheromones in the way that humans think of smelling. A chemoreceptor structure called the vomeronasal organ, or Jacobson’s organ, detects pheromones and other nonvolatile compounds (such as the nepetalactone in catnip). This organ is located near the palate and is part of the accessory olfactory system in cats.")])])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('a', {
    attrs: {
      "id": "day77"
    }
  }), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 89")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("British Shorthair")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMAN INVADERS WENT ON")]), _vm._v(" conquering missions, they brought their cats along. And those felines were a shorthaired breed now two millennia old. Today, the cats are called British Shorthairs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" This sturdily built, round-faced shorthaired cat took on just about every color and pattern, including colorpoint, thanks to mating with various feral cats that already lived in northern Europe. Tabby markings are very common in this breed. They make calm and loyal companions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Although the British Shorthair has long appeared in cat shows in the UK, it was not registered in the United States until 1970, and only then in the solid blue original color. Since then, the U.S. registries have expanded to include other colors and patterns of this breed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" Perhaps this cat should really be called a Latin Shorthair, because it dates back to Roman times. Who knows why the Romans brought cats on their tours? Perhaps the cats were taken north as a kind of feline equivalent of the Trojan Horse, to terrorize British mice into submission. Whatever the case, the cats remained while the Romans were in northern Europe, for four hundred years, and long stayed their original color, too: solid blue.")])]), _c('div', {
    staticClass: "sidebara"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > Artist-writer Harrison Weir (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 303")]), _vm._v(") championed the British Shorthair and made sure this cat was shown prominently in the very first UK cat competition in 1871.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0087-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("British Shorthair")])]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day78"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 90 + 91")])]), _c('a', {
    attrs: {
      "id": "day78"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })])]), _c('p', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "day78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("Resetting Your Cat’s Nocturnal Body Clock")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUR CAT IS A NIGHT PERSON")]), _vm._v(" (er, animal). When the clock strikes midnight, he’s on the prowl, ready to play, prance around the house, or exit your abode to find some nocturnal adventure. Well, maybe his clock isn’t so precise that an alarm goes off at the stroke of twelve, but after snoozing away the daylight hours, he’s bound to feel restless at some point.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You can retrain your cat to be a day-lover (morning cat—that’s pushing it). First, understand a cat’s natural “program” of events: hunt, kill, eat, groom, and nap. In our modern world, that translates to play/pounce, belly up to the food bowl, lick and preen, then fall asleep a happy cat. (Not a bad life, eh?) Here’s how to reset your cat’s body clock so he performs these activities during daylight hours, avoiding all that nighttime racket. The key is to start this cycle in the early evening so his nap and your bedtime coincide.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Remove food bowls in early evening so you can serve a before-bed meal to your cat. (Remember, after eating comes grooming and then "), _c('em', [_vm._v("napping")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Play interactive games in the evening so your cat can hunt and kill—then eat once you replace his food bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Your cat should groom following his dinner, then settle in for a nap just as you’re ready to tuck in to bed. Prepare a bowl for midnight snacking in case your cat wakes. Do not succumb to his 2 a.m. cries for playtime. He will eventually learn that it’s lights-out until morning.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0088-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('a', {
    attrs: {
      "id": "day79"
    }
  }), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 92")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Taking In a Stray Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ER PITIFUL, MEEK MEOW")]), _vm._v(" just melts your heart. She’s skin and bones, but has a sweet face. You can tell this stray has been fending for herself on the streets for some time. You left the garage door open and in she went. You want to gather her up in your arms and take her inside, give her a bath and a gourmet kitty meal. This baby deserves some serious TLC.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The only problem, well there are several: You already own two cats, and this little stray doesn’t come with medical records attached—she may carry a disease such as feline AIDS (FIV) that would fatally harm your indoor cats. You’re a socially conscious cat lover, but taking in this stray could be a very bad idea.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before you jeopardize your household, think “safety first.” What are your intentions, here? Do you want to adopt the cat and assimilate her into your home? Do you simply want to make sure she gets medical care and is spayed? Regardless, the first step will be to “trap” her, which sounds inhumane, but you’re more or less reeling her in to your care. Do this by placing food in the spot where she knows meals are plentiful, if you’ve already been offering; if not, place food inside a crate near the spot where you found her. When you see the cat go inside to eat, close the crate door. Provide food and water for her inside the crate, and call the vet immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your first priority is a thorough checkup for Kitty. She’ll need to be checked for internal parasites, rabies, ringworm, fleas, and serious disease such as FIV (feline AIDS). If she is not spayed, either ask your vet to perform the procedure or take the kitty to a shelter or a pet vaccination clinic for a lost-cost or free spay. Commonly, stray cats present with rhinotracheitis, which is feline herpes, a respiratory tract infection that can lead to more serious disease.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("If the stray is immunized, spayed, and perfectly healthy aside from the need for human attention, you may decide to adopt her into your home. If you do, there is the issue of acclimating the cat to the other feline veterans of the household (see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day098#day106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 123")]), _vm._v("). This is a gradual process. Be prepared to put your cat up for adoption if the union between existing cats and this newbie simply will not work. (Remember, who was there first? There are many loving homes that would benefit from adopting a feline friend.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you decide not to keep the cat, you can enlist her in a foster program as an alternative to taking her to the shelter; or find a no-kill shelter. If you do decide to welcome the stray into your home, you join a hearty population of cat owners who, when asked how they got their cat, say, “She just showed up one day and decided this was home.”")]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day80"
    }
  }), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 93")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("The Colorful Cats of Andrew Lang")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("COTTISH-BORN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDREW LANG")]), _vm._v(" (1844–1912) is best known today for his variously hued collections of fairy tales and folktales from around the world, including his retellings of “Puss in Boots” and several Grimm stories. He wrote several others about cats; all can be read at ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.mythfolklore.net/andrewlang/indextitle.htm",
      "target": "_blank"
    }
  }, [_vm._v("www.mythfolklore.net/andrewlang/indextitle.htm")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• “The Cat’s Elopement” ("), _c('em', [_vm._v("The Pink Fairy Book")]), _vm._v(") is a Japanese tale about two neighboring cats, Gon and Koma, who love each other but are separated by fate.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• “The Colony of Cats” ("), _c('em', [_vm._v("The Crimson Fairy Book")]), _vm._v(") is about a group of cats that rewards a poor girl, Lizina, for living with and taking care of them.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• “The Clever Cat” ("), _c('em', [_vm._v("The Orange Fairy Book")]), _vm._v(") is adapted from a Berber tale, and tells of how said cat, in loyal service to his master, defeats an ogre.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• In “Kisa the Cat” ("), _c('em', [_vm._v("The Brown Fairy Book")]), _vm._v("), an Icelandic story, a princess has been reared with Kisa, a kitten, as her “sister.” When the princess grows up, a giant attacks and abducts her. But Kisa appears to care for and ultimately rescue her . . . which breaks the spell that the cat has been under. She, too, turns out to be a princess.")]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day81"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 94")])]), _c('a', {
    attrs: {
      "id": "day81"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Water Works")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEAN, FRESH WATER IS ESSENTIAL")]), _vm._v(" to life. Water helps prevent many diseases, including kidney and bladder problems, and it flushes out cats’ systems, aiding in digestion. Cats will drink about 1 1/4 to 2 1/2 tablespoons (20 to 40 ml) per pound of body weight per day. This includes water taken in with canned food.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you notice your cat not drinking enough water (a litter box examination will give clues) or consuming more than normal, he may suffer from urinary blockage (male), an infection, or polydipsia that can snowball into more serious medical conditions such as kidney failure. Carefully monitor your cat’s water intake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If he seems uninterested in the dish you provide, consider experimenting with different dishes or water bowl locations. Try a shallow bowl if your cat won’t slurp water from a deep vessel. He may refuse to drink water from a double dish that has compartments for food and water. (Heaven forbid a food chunk spill into his drink.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If your cat drinks from the bathtub or toilet, but not his dish, he probably prefers running water. You can purchase fountains that provide a steady flow of clean, filtered water. Look for one with adjustable flow rates that is tip-proof and easy to dismantle for cleaning.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Otherwise, be sure to refresh kitty’s water bowl several times each day. Also, clean the bowl with soap and warm water daily to prevent bacteria growth.")])]), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('a', {
    attrs: {
      "id": "day81"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "day81"
    }
  }), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0091-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('a', {
    attrs: {
      "id": "day82"
    }
  }), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 95")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Training Kitty to Stay Off the Counters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS LOVE TO PERCH UP HIGH")]), _vm._v(" so they can survey their kingdom and keep an eye on their subjects, even if the kingdom is your living room and you are his subject. Unfortunately, “up high” often includes your kitchen counters. That’s not pleasant or sanitary for you, and it’s not safe for your cat to be up there with the appliances and the hot stove top. How do you keep him off the counters?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First, provide an alternate perch for your cat if there is room for one. A window ledge or cat tree will allow him to see the area from an approved spot while staying out of your way.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Next, make it unpleasant for him to jump onto the counter. Lay out pieces of cardboard side by side to cover the countertops. Apply wide double-stick tape all over the top of the cardboard. Cats hate stickiness on their paws, so if your cat jumps up, he will immediately jump right back down.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The cardboard “trap” is inconvenient for a couple of weeks, but you can move it out of the way when you need to use the counter and put it back when you’re done. If Kitty regresses and returns to the countertop to perch, return the cardboard.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This reminder will refresh his memory and he’ll find a cat-appropriate place to hang out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you catch your cat in the act, use a spray bottle on “stream” to squirt him, and say “no!” in a low, quiet voice. This is most effective when he can’t see where the water is coming from—that is, when he doesn’t know that you’re the one doling out the punishment. Use this method as a complement to the sticky-cardboard trick.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A third method involves setting up empty cans or other easily knocked over items on the edges of the counter. The bang and clatter of falling cans will scare your cat. Unfortunately, the noise also tends to scare people and other innocent animals. Unless you have nerves of steel, proceed with caution and set up this trap while you are away for the day, relying on alternative keep-off methods for nighttime.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Training your cat to stay off countertops takes time—don’t rush it. Give your cat plenty of time to learn the lesson that being on the counter is unpleasant, and he won’t want to go up there again.")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('a', {
    attrs: {
      "id": "day83"
    }
  }), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 96")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Burmese")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LL")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URMESE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CATS TRACE BACK")]), _vm._v(" to a single brown shorthair who lived in Rangoon, now known as Yangon. Her name was Wong Mau, and in 1930 she came to the United States, where Dr. Joseph Thompson introduced her to a seal point Siamese. They produced a mixed litter of Siamese and brown kittens. Mating these latter offspring to each other or to their mother equally produced more brown kittens, and the breed began. (Others, which were dark and had colorpointing, led to the emergence of the Tonkinese breed; see ")]), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day208#day275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Day 320")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" The Burmese is round-faced, with very short fur. In the United States, the only colors accepted in competitions are champagne (a warm beige), platinum (a pinkish pale gray), brown, and blue; other countries permit not only other solid colors but also various tortie tones. (The Malayan is an early term for a Burmese with blue, chocolate, or platinum fur, and is no longer in use by registries.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The British body type is a little more exotic than the American one. Some modern U.S. Burmese are being bred to have a flatter face, more like a Persian’s (this can cause facial deformities such as cleft palate and it is not to be encouraged).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Burmese is the ideal house cat, tolerant of children and so friendly that it would not survive well outdoors. They love company and live best with a companion cat if you can’t be there to serve their emotional needs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" Although the Burmese was recognized in the mid-1930s, after eleven years passed, the breed was pulled from registration in the Cat Fanciers Association (CFA), after pressure from Siamese cat breeders who objected to the very brief lineage as being just crossbred Siamese. In 1956, with a few generations of purebred Burmese down the road, the cats were again allowed to enter U.S. shows. Meanwhile, after being introduced into Great Britain in 1947, the Burmese began to branch out into other colors than brown, and then in the 1980s a crossbreeding of Burmese with Chinchilla created the new breed called Burmilla (see "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day89"
    }
  }, [_vm._v("Day 103")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > Burmese are so sociable that the males often participate in raising their mate’s litter—the “house husbands” of the feline world!")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0093-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Burmese")])]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day84"
    }
  }), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 97 + 98")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Journal Prompts, Part I")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILL UP THE JOURNAL YOU CREATED")]), _vm._v(" on ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day22"
    }
  }, [_vm._v("Day 25")]), _vm._v(" with more memories. Here are some writing prompts to stoke your creativity:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• How did you celebrate your cat’s first birthday?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• What interesting “finds” has your cat presented as a gift to you? (When was the last time you set a mousetrap, thanks to your feline’s successful stalking?)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• How did your kitty respond to her first bath?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• How does your kitty “talk” to you when she wants to express happiness, hunger, sadness, frustration, or a need to be alone?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• How do your multiple cats communicate with each other? Which feline is in charge, and how can you tell?")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• How did you pick a name for your cat, and what were some runner-up names that didn’t make the cut? What do you think about those names now? Would you choose a different name for your cat after getting to know her personality better?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0094-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day85"
    }
  }), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 99")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Choosing a Collar")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLARS ARE MORE THAN JUST A PLACE")]), _vm._v(" to hang your cat’s ID tag. The wide variety of collars available today let you make a fashion statement to fit your cat’s personality.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Nylon webbing is a popular material for cat collars, but other choices include leather, vinyl, cotton, hemp, and elastic. Collars come in an extensive variety of colors and patterns. They can be adorned or decorated with everything from rhinestones to metal studs to faux fur and more. Before purchasing a collar with decorations, check to make sure they are securely attached so that your cat can’t scratch them off.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The collar should fit around your cat’s neck snugly, allowing enough room to comfortably slip two fingers underneath.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No matter which material you choose for your cat’s collar, make sure it is designated a “safety collar” or “breakaway collar.” These collars are designed to stretch or come undone if the collar becomes hung up or entangled. Although this feature means you lose the collar and whatever tags are attached, your cat will be able to free himself quickly and safely if he gets stuck on a fence or tree branch and avoid strangulation.")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }), _c('a', {
    attrs: {
      "id": "day86"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 100")])]), _c('a', {
    attrs: {
      "id": "day86"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cats in Classic Literature")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS NOT ONLY BOUND THROUGH")]), _vm._v(" but abound in classic literature. Here are some entertaining examples:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Lemuel Gulliver feels threatened by a Brobdingnanian (giant) cat in Jonathan Swift’s "), _c('em', [_c('strong', [_vm._v("Gulliver’s Travels")])]), _vm._v(" (1726), but the cat is actually more frightened of him!")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Elizabeth Gaskell’s novel "), _c('em', [_c('strong', [_vm._v("Cranford")])]), _vm._v(" (1851) contains a hilarious passage concerning the attempts by several women to retrieve an accidentally lapped-up piece of valuable lace that had been left to soak in a bowl of milk, to wash it.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Charles Dickens’s "), _c('em', [_c('strong', [_vm._v("Bleak House")])]), _vm._v(" (1853) contains three feline characters, Lady Jane, Mr. Jellyby’s cat, and Mr. Vohles’s cat.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• "), _c('strong', [_c('em', [_vm._v("The Master and Margarita")])]), _vm._v(" by Mikhail Bulgakov, published in 1973, includes in its cast an enormous black cat named Behemoth, who can talk and play chess.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• P.G. Wodehouse compiled two cat stories into a 1933 collection, “"), _c('em', [_c('strong', [_vm._v("The Story of Webster")])]), _vm._v("” and “"), _c('em', [_c('strong', [_vm._v("Cats Will Be Cats")])]), _vm._v(",” about the cat Webster and his owner Theodore, a bishop. Theodore sends Webster to live with his nephew Lancelot as a sobering influence on the young man, but Webster returns as dissipated as Lancelot!")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Anne Frank (1921–1945) lived in hiding during World War II with Mouschi the cat, who is chronicled in her famous diary as having had problems with a lack of fresh peat to use for litter.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• American author-editor Peter Gethers’s very doglike gray tabby Norton, a Scottish Fold, not only starred in numerous books, beginning with the 1991 "), _c('em', [_c('strong', [_vm._v("The Cat Who Went to Paris")])]), _vm._v(", but also “authored” "), _c('em', [_c('strong', [_vm._v("Historical Cats")])]), _vm._v(" (1996).")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day86"
    }
  }), _c('a', {
    attrs: {
      "id": "day87"
    }
  }), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 101")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Cats Are Prone to Vomiting")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS VOMIT MORE THAN MOST PETS")]), _vm._v(", and they do so for different reasons. Hairballs are the most common trigger (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day45"
    }
  }, [_vm._v("Day 52")]), _vm._v("), but there are many other reasons why your cat may vomit. Sometimes, vomit is not a cause for concern—particularly if your cat chowed down on a bowl of kibble as if he were eating his last meal. If he inhaled his meal a little too fast, his body will remind him to digest. Mother cats may vomit food to give their kittens a predigested meal. This is a natural instinct, and not a red flag that she has gastrointestinal parasites.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You’ll know by watching your cat whether her retching is cause for concern. She will look anxious, salivate, and swallow repeatedly. She may pace, or come to you for reassurance and comfort. Call your veterinarian if food is not the reason for your cat’s vomiting. Watch out for these warning signs that intestinal parasites, or worse, may be the cause:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Persistent vomiting")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Sporadic vomiting over a period of days or weeks")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Vomiting blood")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Vomiting feces (sign of intestinal obstruction or abdominal trauma)")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Projectile vomiting")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Vomiting foreign objects")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarc"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("If yours is a multicat household, you feed from a communal dish, and your kitties tend to vomit postmeal, some cats may be overeating. Separate your kitties at feeding time, serve individual portions, and dish out smaller meals. That way, they won’t rush to get their share and suffer the digestive consequences.")])]), _vm._v(" "), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "day88"
    }
  }), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 102")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("The Sleepy Cat")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN YOUR CAT IS NOT EATING")]), _vm._v(", grooming himself, or playing with his catnip mouse, chances are he’s sleeping. Most cats sleep twelve to sixteen hours a day, or more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cats are crepuscular, meaning they are most active around dawn and dusk and less active in the middle of the day and the middle of the night. They alternate periods of activity and sleep throughout the day, rather than sleeping in one long stretch. The term "), _c('em', [_vm._v("catnap")]), _vm._v(" didn’t come from nowhere!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cats have different stages of sleep, just like humans. Slow-wave sleep is a light sleep. His breathing slows and his muscles relax a little, but he is still somewhat aware of his environment and is easily awakened by the sound of the can opener or the tweet of a nearby bird.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("Cats spend about three-quarters of their sleep time in slow-wave sleep and the remainder in deep, rapid-eye-movement (REM) sleep. During REM sleep your cat’s eyes move rapidly back and forth. His muscles relax more fully and his breathing slows even more during this critical, restorative period of sleep. In humans, REM sleep is dream sleep, and many experts believe that cats dream, too, during this phase of sleep (see ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day96"
    }
  }, [_vm._v("Days 111")]), _vm._v(" and "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/day001#day96"
    }
  }, [_vm._v("112")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Waking a cat while he’s in deep sleep can provoke a swipe of the claws, so avoid startling him awake with a sudden touch. It’s best to leave your cat alone until he wakes up on his own.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0097-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "day89"
    }
  }), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 103")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Burmilla")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URMILLA")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WAS A GENETIC ACCIDENT")]), _vm._v(", produced in the UK in 1981 when a Chinchilla and a lilac Burmese had a litter that produced four kittens with a silvery coat tipped with black or brown. The owner was so taken with the youngsters’ appearance that she encouraged the breeding to continue among her cats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" The body type and face tilt a bit toward the exotic, even while the cat has a muscular, solid body. Like the Burmese, its fur is very short. But unlike the Burmese, its fur is tipped with a darker tone, especially along the spine, and the tail and upper legs usually exhibit tabby stripes. There are often vertical marks above the eyes, separated by a V-shaped patch of darker fur or additional stripes. The eyes are normally green.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Like their Burmese ancestors, they crave company and make affectionate house cats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" Although Burmilla cats appear in cat shows that permit unregistered mixed breeds, and they achieved championship status in Great Britain during the 1990s, the Burmilla still awaits full recognition as its own breed with American and other European cat fanciers.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > The super-smart Burmilla is especially adept at opening doors and cabinets to seek objects to play with.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0098-01.jpg",
      "width": "400px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Burmilla")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('a', {
    attrs: {
      "id": "day90"
    }
  }), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 104 + 105")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Teaching Children to “Play Nice” with Kitty")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HILDREN LOVE PETS")]), _vm._v(", especially cuddly kittens that are the right size for small hands to hold. Sharing the responsibility of pet ownership with your children can be a valuable experience for them and take some of the load off of you. But don’t be fooled by your child’s insistence that she’ll take care of "), _c('em', [_vm._v("everything")]), _vm._v(", as long as she can have a baby cat to love. Adopting a pet is a family decision. You, ultimately, will be responsible for vet bills, health care issues, supplies, food, and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Before you bring home your new kitten or cat, hold a family meeting and discuss what caring for a cat requires. Help your children understand the responsibilities by relating care and training to their own experiences. Explain that kittens are like babies, and the whole family will help care for this new family member. Pet ownership will provide a lifetime of memories for your children. The key is to set boundaries and assign responsibilities so children understand that Kitty is more than a toy—she’s a part of the family that requires care and attention, too. Establish ground rules before Kitty comes home so everyone is prepared. Hold a family meeting and review these key points:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Discuss the litter box (and why it’s important to keep out).")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Explain that your kitty may need private time so that your children don’t take your cat’s independence personally.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Discuss how to handle the kitten, and depending on the age of your children, you may need to supervise all kitty–child contact.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Create a schedule or assign a responsibility to your child, whether it is setting out food at a certain time of day or making sure the water dish is full—little things that give children a sense of ownership.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Look through cat books together, and discuss different cat traits. Talk about body language and how to tell when Kitty wants to play or be left alone.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Drive home key points by relating a cat’s behaviors to the child’s own: “Sometimes you don’t want Mom to come into your bedroom because you are busy playing. Kitty will feel that way sometimes, too.”")])]), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0100-01.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('a', {
    attrs: {
      "id": "day91"
    }
  }), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 106")])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Choosing the Right Cat Litter")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N THE WILD, CATS ELIMINATE WASTE")]), _vm._v(" in sand or soil and then bury it. A litter box mimics this natural environment indoors. Historically, litter boxes were filled with ashes, sand, or soil. Today, there are many more sanitary choices available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Litters come in two basic types: clumping and nonclumping. All litters require at least daily scooping for solid wastes. Many come in scented and unscented versions as well as multicat, low-dust, and nontracking formulas. Although some litters are marked as being flushable, many plumbers advise against flushing any kind of cat litter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Clumping litters")]), _vm._v(" form solid clumps when liquid is introduced, which makes scooping easy. When the litter level gets low, just add more to the box. The downsides to clumping litters are that the particles are very small and thus tend to scatter, and some kinds can be dustier than traditional litters. Be sure to keep clumping litters far away from your cat’s food and water. Any kind of moisture will cause it to clump and expand, and you don’t want it clumping in your cat’s digestive system. This type of litter must be changed and the box cleaned every three to four weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Nonclumping litters")]), _vm._v(" come in several varieties. With these litters, liquid wastes are absorbed by the litter and remain in the box until the litter is changed. Thus it is necessary to change and clean the box often, usually weekly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Traditional clay-based litters")]), _vm._v(" have been around the longest and tend to be the least expensive of all the litter options. Clay litter can create a lot of dust, although low-dust options are available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Silica-based or “crystal” litters")]), _vm._v(" are similar to traditional clay-based litters, minus the dust. They are the least like what cats are naturally inclined to use, however, and your cat may need some coaxing to use it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Plant-based litters")]), _vm._v(" are made from pine, wheat, corn, or paper. These are the most “green” of the litter options, because they are made from recycled materials or by-products and are biodegradable. These produce little dust and are the least likely to be tracked around the house.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Veterinarians recommend using unscented, nonclumping clay litter for kittens until they are six months old. Otherwise, you simply need to experiment until you find the litter your cat prefers. Those with hypersensitive noses may not like scented litters because of the smell; those with tender paws will probably not like crystals that can irritate sensitive paws; and cats who lick their paws often may not do well with clumping litters.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Regardless of the type of litter you choose, the litter box should be emptied, scrubbed, and refilled regularly—how often will depend on the type of litter used. Cats will not use a foul litter box, and will choose to do their business elsewhere if they encounter one.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }), _c('a', {
    attrs: {
      "id": "day92"
    }
  }), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TUESDAY")])]), _vm._v(" day 107")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Hey, Diddle, Diddle, and other Nursery Rhymes")]), _vm._v(" "), _c('div', {
    staticClass: "blackquote1"
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Hey, diddle, diddle, the cat and the fiddle,")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The cow jumped over the moon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The little dog laughed to see such fun")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("And the dish ran away with the spoon.")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("—Traditional nursery rhyme")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS ARE WELL REPRESENTED IN")]), _vm._v(" traditional nursery rhymes. How many of these do you remember from your days of reading children’s books, or being read to? If you have little kiddies—or kitties—of your own, enjoy quality time reading aloud. Here are some favorites:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Old Mother Hubbard, went to the cupboard, to get her poor dog a bone. In the full-length version of this famous poem, she does quite a bit of shopping, in the course of which she visits a hatter who is too busy feeding his cat to serve her!")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• On the other hand, the hapless kitty in “Great A, Little A” is, itself, shut inside a cupboard.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• That fate is perhaps still better than what happens to the cat in “Ding-Dong-Bell,” in which Little Johnny Green puts Pussy in the well. Luckily, Little Tommy Stout comes along to pull her out.")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• In “Pussy Cat, Pussy Cat, Where Have You Been?” the cat goes to London and there performs a vital service for the queen: catching a mouse he finds beneath a chair (apparently, even royal households had a problem with vermin!).")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Remember the poem about the crooked little man who lived in a crooked little house? He had, you guessed it—a crooked little cat . . . who caught a crooked little mouse!")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Perhaps the cat who makes out best in these little tales is the title character in “Pussy Cat, Pussy Cat, Wilt Thou Be Mine,” who is promised that she will do no labor but sit on silk, sew, and eat strawberries with cream and sugar.")])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('a', {
    attrs: {
      "id": "day93"
    }
  }), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WEDNESDAY")])]), _vm._v(" day 108")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common03.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Preventing Heartworms: A Fatal Parasite")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SINGLE INFECTED MOSQUITO’S BITE")]), _vm._v(" is all it takes for an unprotected cat to get a fatal disease. Mosquitoes are heartworm carriers. If they bite an infected animal, young heartworms called microfilariae enter the mosquito’s system. Larvae develop inside the mosquito, and these can be transmitted the next time a mosquito bites another animal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Heartworms are deadly to cats and dogs, but cats usually do not have microfilariae circulating in their blood. Therefore, it’s not a likely that a cat will transfer heartworms to another mosquito. Instead, cats get the parasite directly from mosquitoes, which sucked up the dangerous microfilariae from an infected dog. The parasite is more commonly found in dogs, but because of the comparatively smaller size of a cat’s heart, a single adult heartworm can wreak havoc. The good news: "), _c('em', [_vm._v("You can protect your cat against heartworms and avoid this parasite completely.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Symptoms:")]), _vm._v(" Because common signs of heartworm infestation are similar to other illnesses, the disease is often not discovered until advanced stages. Your cat may cough and experience respiratory distress or vomiting. Unfortunately, these same symptoms also point to less serious diseases that are easily treated with medications. A cat can suddenly die from heartworms if live heartworms enter pulmonary arteries and obstruct blood flow to the heart, or if heartworms attack the lungs and shut down a cat’s respiratory function.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Diagnosis:")]), _vm._v(" Diagnosing heartworm in cats is more difficult than in dogs. Your vet will perform antigen and antibody tests. The antigen test only detects female heartworms, so its results are not 100 percent accurate. The antibody test determines whether the cat’s immune system has been exposed to the parasite. However, cats with heartworms in places other than the heart (pulmonary arteries, lungs) will test positive in an antigen test. Both tests are necessary to confirm diagnosis of heartworms. Additionally, cats can be tested for normal white blood cells, but this is also not a surefire way to detect heart-worm presence because normal white blood cell count is elevated for only the first few months of infestation, and cats with allergies or intestinal parasites also have a higher than normal white blood cell count. X-rays and ultrasounds may be used to detect the size of pulmonary arteries—bloated arties can indicate parasitic presence. With these methods, a vet may actually see heartworms in the cat’s body.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Treatment:")]), _vm._v(" There is currently no safe and effective medical treatment aside from antiinflammatory medications or surgery to remove the heartworm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Prevention:")]), _vm._v(" If your cat is not currently taking preventive heartworm medication, get him tested, even if he shows no signs of sickness. Your vet should test your cat annually for heartworms just to make sure he is not infected. FDA-approved monthly heartworm preventives advised by your veterinarian will not eliminate the heartworm infection if it already exists, but it will protect a cat from heartworms.")])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }), _c('a', {
    attrs: {
      "id": "day94"
    }
  }), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THURSDAY")])]), _vm._v(" day 109")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common04.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Hiding Places")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS LOVE COZY HIDING PLACES")]), _vm._v(", and they’re always seeking out new spots to nap. Don’t get too worried if you don’t see her for a while. She may have found a new secret hiding place where she can enjoy some privacy. However, if your cat misses mealtime or doesn’t respond to the rattle of her favorite toy after a couple of tries, she could be stuck somewhere or hiding out because she’s sick. That’s your clue to start scouring the house. Here are some common hiding spots:")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Under or behind large pieces of furniture, such as beds, sofas, armoires, and chests of drawers")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Inside cabinets")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Inside low drawers, especially those containing clothing or linens")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Behind curtains")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Under blankets or bedclothes")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Under pillows on the bed or sofa")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Behind doors")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Inside boxes or bags")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• In the bathtub")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• In the space behind the drawer and the back panel of a chest of drawers")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Under the dining table on a chair")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• On top of a cabinet or tall piece of furniture")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Inside a reclining chair mechanism")]), _vm._v(" "), _c('p', {
    staticClass: "bulletlist"
  }, [_vm._v("• Behind the toilet (especially on a hot day)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Some hiding places can be dangerous.")]), _vm._v(" Always check inside the clothes dryer and other large appliances before closing the door and inside a reclining chair mechanism or sofa bed before closing it. If your cat goes outdoors in cold weather, always knock on the hood before starting the car; cats will sometimes crawl up into the engine compartment for warmth.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0104-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('a', {
    attrs: {
      "id": "day95"
    }
  }), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FRIDAY")])]), _vm._v(" day 110")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("California Spangled")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITH A NAME LIKE")]), _vm._v(" “California Spangled,” one would almost expect such a cat to have sequined fur.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Characteristics:")]), _vm._v(" This handsome newcomer to the feline community looks like a jungle beast crossed with a sweet little tabby. The mediumsize cat has a wild posture, close to the ground, and an unusually blunt-tipped tail. Its short fur comes in a broad range of tabby colors, from gold through bronze, red, and brown, to charcoal and black. In all cases, the cat is prolifically spotted, with close bars around its legs and tail, and the classic tabby "), _c('em', [_vm._v("M")]), _vm._v(" on the forehead. Its eyes tend to be amber.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The California Spangled’s complex family tree has worked to its favor to produce highly intelligent, strong cats. Despite its wild appearance, the Spangled has no wildcat blood, and is an affectionate household cat—assuming you can afford to bring it home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("History:")]), _vm._v(" The breed was the brainchild of scientist Paul Casey, who, after ten years of interbreeding among eight standard breeds, including Abyssinian and Siamese, produced in the early 1980s the beautiful striped and spotted markings that have become standard to the Spangled.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Early examples of this cat were so expensive and rare that in 1986, the famed Neiman-Marcus department store offered a pair of California Spangled in its “His and Hers” Christmas section, each cat at that time costing more than a thousand dollars. In that same year, the California Spangled was accepted for registration in the United States.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebara"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > Regardless of whichever color later develops, every California Spangled kitten is born black!")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "475px"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "100%",
      "src": "images/f0105-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("California Spangled")])])]), _c('p', {
    staticClass: "dayla"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }), _c('a', {
    attrs: {
      "id": "day96"
    }
  }), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SATURDAY + SUNDAY")])]), _vm._v(" days 111 + 112")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('p', {
    staticClass: "dayl"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0005-06.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Is Your Cat Dreaming?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATS CAN SNOOZE MOST OF THE DAY")]), _vm._v("—they never hesitate to make themselves comfortable, whether that means stretching out on a cozy comforter or tucking into a peaceful ball of fluff. Cats enter light sleep and intense REM cycles, when the brain is active and their body responds accordingly. Their paws flex, claws extend and retract, their kitty whiskers twitch, and they mumble softly in meow-gibberish. Cats spend about 30 percent of their sleeping time in deep sleep, when dreaming occurs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What could your cat be dreaming? Consider his basic instincts. While our house cats aren’t wildly chasing down prey, the paw movement in their dreams could be your cat pouncing on his victim.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cats remember past experiences, and these can surface subconsciously during sleep. This is a good thing, actually. Dreaming is vital to a cat’s health. It’s a time for data processing and memory storage, for mental replenishment and brain development.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There’s great temptation to wake your cat during REM sleep, especially when he is thrashing his paws or meowing as if he’s in a heated debate with the family dog. Our natural instinct is to “save” the cat from the bad dream by consoling him: Here, here, mommy’s right by your side. Despite activity taking place in the room, a cat in REM is not easily awakened. If you do choose to wake your cat from a nightmare, do so gently by petting him and speaking in a calm, reassuring voice.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0106-01.jpg",
      "width": "400px"
    }
  })])]), _c('p', {
    staticClass: "dayra"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }), _c('a', {
    attrs: {
      "id": "day97"
    }
  }), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MONDAY")])]), _vm._v(" day 113")])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('p', {
    staticClass: "dayr"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Your Cat’s Age in Human Years")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDOOR CATS, PROTECTED AGAINST")]), _vm._v(" the elements, disease, and predators, typically live fifteen years or even older, which in human years means that they can live to eighty or beyond!")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarax"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_c('em', [_vm._v("feline fun fact")])]), _vm._v(" > The oldest cat ever was Cream Puff, who reached the age of 38. That’s 144 in human years.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_vm._v("Here is how Kitty’s age compares roughly with that of humans:")]), _vm._v(" "), _c('table', {
    staticClass: "sidebaraaz",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "50%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_c('strong', [_vm._v("AGE IN YEARS")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("CAT")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("HUMAN")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("34")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("42")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("8")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("50")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("54")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("58")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("62")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("65")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("13")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("14")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("72")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("15")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("75")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("16")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("78")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("17")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("81")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("18")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("84")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("19")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("87")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("20")])]), _vm._v(" "), _c('td', {
    staticClass: "white",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table-c"
  }, [_vm._v("90")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be8b301a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/day001.vue
// module id = 75
// module chunks = 0